import { Box, Divider, Grid, IconButton, Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import _ from 'lodash'
import moment from 'moment'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { UseSnCode } from 'utils/useSnCode'
/** TRANSLATION */
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import { useTranslation } from 'react-i18next'

/** STYLE */
import { colors } from 'constants/theme'
import * as UseStyles from 'features/setting/branch-service-point/branch/style'

/** API */
import { fileUrl } from 'api/api'
import ComponentApi from 'api/components-api'
import BranchApi from 'api/setting/branch-service-points/branch.api'
import ServicePointApi from 'api/setting/branch-service-points/service-point.api'
import BanksApi from 'api/setting/finances/bank.api'

/** CONSTANT */
import { icons, onImgError } from 'constants/images'

/** COMPONENT */
import { notiError, notiSuccess } from 'component/notifications/notifications'
import BasicSelect from 'component/Select/BasicSelect'
import UploadImage from 'component/Upload/UploadImage'
import { routeName } from 'routes/routes-name'

import { ButtonInfoSimple } from 'component/Button/ButtonInfo'
import InputNewRangeTimePicker from 'component/Input/InputNewRangeTimePicker'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'

/** RECEIPT FORMAT */
// Old
// import Thermal1 from 'assets/images/receipt-format/thermal-1.png'
// import Thermal2 from 'assets/images/receipt-format/thermal-2.png'
// import Thermal3 from 'assets/images/receipt-format/thermal-3.png'
// New
// ReceiptThermal-1

import $ from 'jquery'
import FormFormatForm from './form-formatform'
import FormTemplaceDocDentist, { FormTemplaceDocDentisInfo, ModalExamDoc, ModalExamDocTitle, TemplaceDocInfo } from './form-templace-doc-dentist'

// pdf example
import OPD_CARD_APPOINTMENT from '../../../../assets/branch/templaceDoc/OPD_APPOINTMENT.png'
import OPD_CARD_BLANK_1 from '../../../../assets/branch/templaceDoc/OPD_CARD_BLANK_1.png'
import OPD_CARD_BLANK_2 from '../../../../assets/branch/templaceDoc/OPD_CARD_BLANK_2.png'
import OPD_CARD_COVER from '../../../../assets/branch/templaceDoc/OPD_CARD_COVER.png'
import OPD_CARD_COVER_V1 from '../../../../assets/branch/templaceDoc/OPD_CARD_COVER_V1.png'
import OPD_CARD_HOSPITAL_1 from '../../../../assets/branch/templaceDoc/OPD_CARD_HOSPITAL_1.png'
import OPD_CARD_HOSPITAL_2 from '../../../../assets/branch/templaceDoc/OPD_CARD_HOSPITAL_2.png'
import OPD_CARD_V1 from '../../../../assets/branch/templaceDoc/OPD_CARD_V1.png'

import DENTALREFERRAL from '../../../../assets/branch/templaceDoc/DENTALREFERRAL.png'
import REFERRALPATIENT from '../../../../assets/branch/templaceDoc/REFERRALPATIENT.png'
import REFERRALPATIENTBLANK from '../../../../assets/branch/templaceDoc/REFERRALPATIENTBLANK.png'

import DENTISTCERTIFICATE from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATE.png'
import DENTISTCERTIFICATE_BLANK from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATE_BLANK.png'
import DENTISTCERTIFICATE_BLANK_EN from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATE_BLANK_EN.png'
import DENTISTCERTIFICATE_EN from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATE_EN.png'
import DENTISTCERTIFICATEA5 from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATEA5.png'
import DENTISTCERTIFICATEA5_BLANK from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATEA5_BLANK.png'
import DENTISTCERTIFICATEA5_EN from '../../../../assets/branch/templaceDoc/DENTISTCERTIFICATEA5_EN.png'
import DOCTORCERTIFICATE_A5_EN_BLANK from '../../../../assets/branch/templaceDoc/DOCTORCERTIFICATE_A5_EN_BLANK.png'
import DOCTORCERTIFICATEFOR5DISEASES from '../../../../assets/branch/templaceDoc/DOCTORCERTIFICATEFOR5DISEASES.png'
import DOCTORCERTIFICATEFOR5DISEASES_BLANK from '../../../../assets/branch/templaceDoc/DOCTORCERTIFICATEFOR5DISEASES_BLANK.png'
import DOCTORCERTIFICATEFOR5DISEASES_EN from '../../../../assets/branch/templaceDoc/DOCTORCERTIFICATEFOR5DISEASES_EN.png'
import DOCTORCERTIFICATEFOR5DISEASES_EN_BLANK from '../../../../assets/branch/templaceDoc/DOCTORCERTIFICATEFOR5DISEASES_EN_BLANK.png'
import DRIVERLICENSEDOCTORCERTIFICATE from '../../../../assets/branch/templaceDoc/DRIVERLICENSEDOCTORCERTIFICATE.png'
import DRIVERLICENSEDOCTORCERTIFICATE_BLANK from '../../../../assets/branch/templaceDoc/DRIVERLICENSEDOCTORCERTIFICATE_BLANK.png'
import DRIVERLICENSEDOCTORCERTIFICATE_EN from '../../../../assets/branch/templaceDoc/DRIVERLICENSEDOCTORCERTIFICATE_EN.png'
import DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK from '../../../../assets/branch/templaceDoc/DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK.png'

import DRUGSTICKER from '../../../../assets/branch/templaceDoc/DRUGSTICKER.png'
import MEDICALSERVICEUSAGEFORM from '../../../../assets/branch/templaceDoc/MEDICALSERVICEUSAGEFORM.png'
import PDFINVOICE from '../../../../assets/branch/templaceDoc/PDFINVOICE.png'
import SOCIALSECURITYCERTIFICATE from '../../../../assets/branch/templaceDoc/SOCIALSECURITYCERTIFICATE.png'
import SOCIALSECURITYCERTIFICATE_BACK from '../../../../assets/branch/templaceDoc/SOCIALSECURITYCERTIFICATE_BACK.png'
//import PDFINVOICE from '../../../../assets/branch/templaceDoc/PDFINVOICE.jpg'
import PDFINVOICEFEE from '../../../../assets/branch/templaceDoc/PDFINVOICEFEE.png'

import OUTSTANDINGPAYMENT from '../../../../assets/branch/templaceDoc/OUTSTANDINGPAYMENT.png'
import OUTSTANDINGPAYMENT_SAVE2 from '../../../../assets/branch/templaceDoc/OUTSTANDINGPAYMENT_SAVE2.png'

import { showModal } from 'app/slice/modal.slice'
import { swalWarning } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import HelperText from 'component/Input/HelperText'
import Loading from 'component/Loading'
import SelectAddress from 'component/Select/SelectAddress'
import { Config } from 'config'
import { APPOINTMENT_SHARING, CODE_OPERATIVE } from 'constants/status'
import CheckboxButton from 'new-components/buttons/checkbox-button'
import MainButton from 'new-components/buttons/main-button'
import RadioButton from 'new-components/buttons/radio-button'
import TextAreaInput from 'new-components/inputs/text-area-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import { useDispatch } from 'react-redux'
import { getToken } from 'utils/app.utils'
import FormBranchReceiptSticker from './form-branch-receipt-sticker'
import FormBranchSetting from './form-setting'

export enum TIME_APPOINTMENT {
  CLINIC = `CLINIC`,
  SCHEDULE = `SCHEDULE`,
}

export enum PATIENT_CODE {
  PT = `0`,
  CN = `1`,
  SN = `2`
}

export enum TREATMENT {
  TYPE = `2`,
  TX = `1`
}

export enum DEFAULT_DF_REPORT {
  PAY = `0`,
  OP = `1`
}

export enum DEFAULT_DF_CON {
  PAY_1 = `0`,
  PAY_2 = `1`,
  PAY_3 = `2`,
  PAY_4 = `3`,
  PAY_5 = `4`,
}

export enum CALCULATE_ADVANCE {
  INCREASE = `INCREASE`,
  DECREASE = `DECREASE`,
}

const initStateErrorMessage = {
  BRANCH_CODE: '',
  IS_DUPLICATE_BRANCH_CODE: '',
  BRANCH_CODE_STRING_BASE: '',
  BRANCH_CODE_STRING_EMPTY: '',
  BRANCH_CODE_MAXIMUM_LENGTH: '',
  BRANCH_CODE_ANY_REQUIRED: '',

  BRANCH_NUMBER: '',
  IS_DUPLICATE_BRANCH_NUMBER: '',
  BRANCH_NUMBER_STRING_BASE: '',
  BRANCH_NUMBER_STRING_EMPTY: '',
  BRANCH_NUMBER_MAXIMUM_LENGTH: '',
  BRANCH_NUMBER_ANY_REQUIRED: '',

  BRANCH_NAME: '',
  IS_DUPLICATE_BRANCH_NAME: '',
  BRANCH_NAME_STRING_BASE: '',
  BRANCH_NAME_STRING_EMPTY: '',
  BRANCH_NAME_MAXIMUM_LENGTH: '',
  BRANCH_NAME_ANY_REQUIRED: '',

  BRANCH_NAME_EN: '',
  IS_DUPLICATE_BRANCH_NAME_EN: '',
  BRANCH_NAME_EN_STRING_BASE: '',
  BRANCH_NAME_EN_STRING_EMPTY: '',
  BRANCH_NAME_EN_MAXIMUM_LENGTH: '',
  BRANCH_NAME_EN_ANY_REQUIRED: '',

  BRANCH_LICENSE: '',
  BRANCH_TAX: '',
  BRANCH_PHONE: '',
  BRANCH_TEL: '',
  BRANCH_FAX: '',
  BRANCH_LINE: '',
  BRANCH_WEBSITE: '',
  BRANCH_EMAIL: '',
  BRANCH_FACEBOOK: '',
  BRANCH_INSTAGRAM: '',
  BRANCH_ADDRESS: '',
  BRANCH_ADDRESS_EN: '',

  EMPTY_BANK_ACCOUNT_NAME: '',
  EMPTY_BANK_ACCOUNT_NUMBER: '',

  WORK_TIME_LIST: '',
  WORK_TIME: '',

  SERVICE_POINT: ''
}

const initStateEditData = {
  branchId: '',
  branchCode: '',
  branchAddress: '',
  branchAddressEn: '',
  branchEmail: '',
  branchFacebook: '',
  branchFax: '',
  branchFullAddress: '',
  branchFullAddressEn: '',
  branchInstagram: '',
  branchLicense: '',
  branchLine: '',
  branchName: '',
  branchNameEn: '',
  hospitalName: '',
  hospitalCode: '',
  branchNumber: '',
  branchPhone: '',
  branchTax: '',
  branchTel: '',
  branchWebsite: '',
  countryId: '',
  defaultReceipt: '',
  defaultReceiptRemarkStatus: '',
  defaultReceiptPracticeStatus: '',
  districtId: '',
  latitude: '',
  longitude: '',
  postcode: '',
  provinceId: '',
  hasRecieptAddress: '',
  receiptAddress: '',
  receiptAddressEn: '',
  receiptCountryId: null,
  receiptProvinceId: '',
  receiptDistrictId: '',
  receiptSubDistrictId: '',
  receiptPostcode: '',
  receiptFullAddress: '',
  receiptFullAddressEn: '',
  opdCard: '',
  opdCardCover: '',
  opdCardBlank: '',
  opdCardHospital: '',
  dentistCertificate: '',
  dentistCertificateBlank: '',

  showCostEstimateReceipt: '',

  receiptA5Default: '',
  receiptA5Original: '',
  receiptA5Copy: '',
  receiptA5DefaultEn: '',
  receiptA5OriginalEn: '',
  receiptA5CopyEn: '',
  receiptA5DefaultLandscape: '',
  receiptA5OriginalLandscape: '',
  receiptA5CopyLandscape: '',
  receiptA5DfLscape: '',
  receiptA5DfOrgLscape: '',
  receiptA5DfCopyLscape: '',
  receiptA4Default: '',
  receiptA4Original: '',
  receiptA4Copy: '',
  receiptThermal: '',
  receiptThermalDf: '',

  receiptA5FixDfLscape: '',
  receiptA5FixDfOrgLscape: '',
  receiptA5FixDfCopyLscape: '',

  drugSticker: '',
  doctorCertificate: '',
  doctorCertificateFor5Diseases: '',
  driverLicenseDoctorCertificate: '',
  doctorCertificateA5: '',
  referralPatient: '',
  referralPatientBlank: '',
  dentalReferral: '',
  opdCardForPrint: '',
  socialSecurityCertificate: '',
  medicalServiceUsageForm: '',

  pdfInvoice: '',
  pdfInvoiceTreatment: '',
  pdfInvoiceTreatmentCondition: '',

  outStandingPayment: '',

  status: '',
  subDistrictId: '',
  thermalFormat: '',
  receiptNumberPrefix: '',
  thermalRemark: '',
  timeIn: '',
  timeOut: '',
  updatedAt: '',
  updatedBy: '',
  createdAt: '',
  createdBy: '',
  bankAccounts: [{}],
  branchServicePoints: [{}, {}],
  officeTimes: [{}],
  branch_logo: [],
  branch_logo_thermal: [],
  branch_image: [],

  patientCodeAppointment: '',
  patientCodeLab: '',
  stickerFormat: '',

  addressMap: '',

  opdCardBlank2: '',
  dentistCertificateEn: '',
  dentistCertificateBlankEn: '',
  doctorCertificateFor5DiseasesEn: '',
  doctorCertificateFor5DiseasesBlank: '',
  doctorCertificateFor5DiseasesBlankEn: '',
  driverLicenseDoctorCertificateEn: '',
  driverLicenseDoctorCertificateBlank: '',
  driverLicenseDoctorCertificateBlankEn: '',
  doctorCertificateA5En: '',
  doctorCertificateA5Blank: '',
  doctorCertificateA5BlankEn: '',

  opdCardFirst: '',
  opdCardAppointment: '',

  formRegister: '',
  formAppointment: '',

  apptService: '',
  qrCodeReceiptDetail: '',
  qrCodeReceipt: [],

  showAppointmentSharing: APPOINTMENT_SHARING.NOT_DISPLAYED,
  showOperativeCode: CODE_OPERATIVE.NOT_DISPLAYED,
  calculateAdvance: CALCULATE_ADVANCE.INCREASE,
  timeAppointment: TIME_APPOINTMENT.CLINIC,
  defaultDfReport: DEFAULT_DF_REPORT.PAY,
  defaultDfCon: DEFAULT_DF_CON.PAY_1,
  patientCodeQueue: PATIENT_CODE.CN,
}

interface BranchBankInterface {
  bankId: number
  bankName: string
  bankAccountName: string
  bankAccountNumber: string
  hasTransfer: boolean | string
  hasCredit: boolean | string
  hasDebit: boolean | string
  disabledTransfer: boolean
  disabledCredit: boolean
  disabledDebit: boolean
}

interface BranchOfficeTimesInterface {
  dayOfWeek: string
  timeIn: string
  timeOut: string
  officeStatus: string
}
export interface BranchSelectAddressInterface {
  district_id?: any
  district_name_en?: any
  district_name_th?: any
  latitude?: any
  longtitude?: any
  postcode?: any
  province_id?: any
  province_name_en?: any
  province_name_th?: any
  sub_district_id?: any
  sub_district_name_en?: any
  sub_district_name_th?: any
}
interface BanksInterface {
  bankId: any
  bankShortname: any
  bankName: any
  bankLogo: any
  hasTransfer: any
  hasCredit: any
  hasDebit: any
}
interface ServicePointInterface {
  servicePointId: any
  servicePointMenus: any
  servicePointName: any
  servicePointNameEn: any
}

export default function FormBranch() {
  const objImage = { fileId: null, base64: '', fileExtension: '', fileSize: '' }
  const objBranchTime = [
    {
      typetime: 'OPEN',
      timeStart: '00:00',
      timeEnd: '00:00',
      days: { sun: false, mon: false, tue: false, wed: false, thu: false, fri: false, sat: false }
    }
  ]

  const objBranchServicePoint = [
    {
      servicePointId: 0
    }
  ]

  const location = useLocation()
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [branchLogoData, setBranchLogoData] = useState<any>()
  const [branchLogo, setBranchLogo] = useState(objImage)
  const [branchImageData, setBranchImageData] = useState<any>()
  const [branchImageDataId, setBranchImageDataId] = useState<any>(0)
  const [branchImage, setBranchImage] = useState(objImage)
  const [branchLogoThermalData, setBranchLogoThermalData] = useState<any>()
  const [branchLogoThermalDataId, setBranchLogoThermalDataId] = useState<any>(0)
  const [branchLogoThermal, setBranchLogoThermal] = useState(objImage)
  const [loading, setLoading] = useState(false)
  const [initLocation, setInitLocation] = useState({})
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [editData, setEditData] = useState(initStateEditData)

  const [branchId, setBranchId] = useState(Number)

  const [branchTab, setBranchTab] = useState('INFORMATION')

  const [branchCode, setBranchCode] = useState('')
  const [branchNumber, setBranchNumber] = useState('')
  const [branchName, setBranchName] = useState('')
  const [branchNameEn, setBranchNameEn] = useState('')
  const [hospitalName, setHospitalName] = useState('')
  const [hospitalCode, setHospitalCode] = useState('')
  const [branchLicense, setBranchLicense] = useState('')
  const [branchTax, setBranchTax] = useState('')
  const [branchPhone, setBranchPhone] = useState('')
  const [branchTel, setBranchTel] = useState('')
  const [branchFax, setBranchFax] = useState('')
  const [branchLine, setBranchLine] = useState('')
  const [branchWebsite, setBranchWebsite] = useState('')
  const [branchEmail, setBranchEmail] = useState('')
  const [branchFacebook, setBranchFacebook] = useState('')
  const [branchInstagram, setBranchInstagram] = useState('')
  const [country, setCountry] = useState<any>()
  // const [branchSelectAddress, setBranchSelectAddress] = useState<BranchSelectAddressInterface>()
  const [branchSelectAddress, setBranchSelectAddress] = useState<BranchSelectAddressInterface>({
    province_id: 0,
    district_id: 0,
    sub_district_id: 0,
    postcode: ''
  });
  const [branchAddress, setBranchAddress] = useState('')
  const [branchAddressEn, setBranchAddressEn] = useState('')

  const [receiptCountry, setRecieptCountry] = useState<any>()
  const [receiptSelectAddress, setRecieptSelectAddress] = useState<BranchSelectAddressInterface>()
  const [receiptAddress, setRecieptAddress] = useState('')
  const [receiptAddressEn, setRecieptAddressEn] = useState('')
  const [addressRecieptSameBranch, setAddressRecieptSameBranch] = useState(true)
  const [defaultReceipt, setDefaultReceipt] = useState('THERMAL')
  const [defaultReceiptRemarkStatus, setDefaultReceiptRemarkStatus] = useState<any>('1')
  const [defaultReceiptPracticeStatus, setDefaultReceiptPracticeStatus] = useState<any>('1')
  const [thermalFormat, setThermalFormat] = useState('FORMAT_1')
  const [receiptNumberPrefix, setReceiptNumberPrefix] = useState('CN')
  const [thermalRemark, setThermalRemark] = useState('')
  const [opdCard, setOpdCard] = useState(true)
  const [opdCardCover, setOpdCardCover] = useState(true)
  const [opdCardBlank, setOpdCardBlank] = useState(true)
  const [opdCardFirst, setOpdCardFirst] = useState(true)
  const [opdCardAppointment, setOpdCardAppointment] = useState(true)
  const [opdCardCoverV1, setOpdCardCoverV1] = useState(true)
  const [opdCardHospital, setOpdCardHospital] = useState(true)
  const [dentistCertificate, setDentistCertificate] = useState(true)
  const [dentistCertificateBlank, setDentistCertificateBlank] = useState(true)

  const [showCostEstimateReceipt, setShowCostEstimateReceipt] = useState('1')

  const [opdCardBlank2, setOpdCardBlank2] = useState<boolean>(true)
  const [dentistCertificateEn, setDentistCertificateEn] = useState<boolean>(true)
  const [dentistCertificateBlankEn, setDentistCertificateBlankEn] = useState<boolean>(true)
  const [doctorCertificateFor5DiseasesEn, setDoctorCertificateFor5DiseasesEn] = useState(true)
  const [doctorCertificateFor5DiseasesBlank, setDoctorCertificateFor5DiseasesBlank] = useState(true)
  const [doctorCertificateFor5DiseasesBlankEn, setDoctorCertificateFor5DiseasesBlankEn] = useState(true)
  const [driverLicenseDoctorCertificateEn, setDriverLicenseDoctorCertificateEn] = useState(true)
  const [driverLicenseDoctorCertificateBlank, setDriverLicenseDoctorCertificateBlank] = useState(true)
  const [driverLicenseDoctorCertificateBlankEn, setDriverLicenseDoctorCertificateBlankEn] = useState(true)
  const [doctorCertificateA5En, setDoctorCertificateA5En] = useState(true)
  const [doctorCertificateA5Blank, setDoctorCertificateA5Blank] = useState(true)
  const [doctorCertificateA5BlankEn, setDoctorCertificateA5BlankEn] = useState(true)

  const [receiptA5Default, setReceiptA5Default] = useState(true)
  const [receiptA5Original, setReceiptA5Original] = useState(true)
  const [receiptA5Copy, setReceiptA5Copy] = useState(true)
  const [receiptA5DefaultEn, setReceiptA5DefaultEn] = useState(true)
  const [receiptA5OriginalEn, setReceiptA5OriginalEn] = useState(true)
  const [receiptA5CopyEn, setReceiptA5CopyEn] = useState(true)
  const [receiptA5DefaultLandscape, setReceiptA5DefaultLandscape] = useState(true)
  const [receiptA5OriginalLandscape, setReceiptA5OriginalLandscape] = useState(true)
  const [receiptA5CopyLandscape, setReceiptA5CopyLandscape] = useState(true)
  const [receiptA5DfLscape, setReceiptA5DfLscape] = useState(true)
  const [receiptA5DfOrgLscape, setReceiptA5DfOrgLscape] = useState(true)
  const [receiptA5DfCopyLscape, setReceiptA5DfCopyLscape] = useState(true)
  const [receiptA4Default, setReceiptA4Default] = useState(true)
  const [receiptA4Original, setReceiptA4Original] = useState(true)
  const [receiptA4Copy, setReceiptA4Copy] = useState(true)
  const [receiptThermal, setReceiptThermal] = useState(true)
  const [receiptThermalDf, setReceiptThermalDf] = useState(true)

  const [receiptA5FixDfLscape, setReceiptA5FixDfLscape] = useState(true)
  const [receiptA5FixDfOrgLscape, setReceiptA5FixDfOrgLscape] = useState(true)
  const [receiptA5FixDfCopyLscape, setReceiptA5FixDfCopyLscape] = useState(true)

  const [drugSticker, setDrugSticker] = useState(true)
  const [doctorCertificate, setDoctorCertificate] = useState(true)
  const [doctorCertificateFor5Diseases, setDoctorCertificateFor5Diseases] = useState(true)
  const [driverLicenseDoctorCertificate, setDriverLicenseDoctorCertificate] = useState(true)
  const [doctorCertificateA5, setDoctorCertificateA5] = useState(true)

  const [pdfInvoice, setPdfInvoice] = useState(true)
  const [pdfInvoiceTreatment, setPdfInvoiceTreatment] = useState(true)
  const [pdfInvoiceTreatmentCondition, setPdfInvoiceTreatmentCondition] = useState<string>('0')

  const [outStandingPayment, setOutStandingPayment] = useState<boolean>(true)

  const [referralPatient, setReferralPatient] = useState(true)
  const [referralPatientBlank, setReferralPatientBlank] = useState(true)
  const [dentalReferral, setDentalReferral] = useState(true)
  const [opdCardForPrint, setOpdCardForPrint] = useState(true)
  const [socialSecurityCertificate, setSocialSecurityCertificate] = useState(true)
  const [medicalServiceUsageForm, setMedicalServiceUsageForm] = useState(true)

  const [branchTimes, setBranchTimes] = useState([...objBranchTime])
  const [branchServicePoints, setBranchServicePoints] = useState([...objBranchServicePoint])

  const [banks, setBanks] = useState<BanksInterface[]>([])
  const [branchBanks, setBranchBanks] = useState<BranchBankInterface[]>([])
  const [servicePoints, setServicePoint] = useState<ServicePointInterface[]>([])

  const [countryOptions, setCountryOptions] = useState<any[]>([])

  const [patientCodeAppointment, setSettingAppointment] = useState<any>('1')
  const [patientCodeLab, setSettingLab] = useState<any>('1')
  const [stickerFormat, setStickerFormat] = useState('FORMAT_1')
  const [snType, setSnType] = useState(false)



  const [qrCodeReceiptDetail, setQRCodeReceiptDetail] = useState<string>('')
  const [qrCodeReceipt, setQRCodeReceipt] = useState<any>(objImage)
  const [imgQRData, setImgQRData] = useState<string>("")
  const [formRegister, setFormRegister] = useState([])
  const [formAppointment, setFormAppointment] = useState([])
  const [addressMap, setAddressMap] = useState<string>('')
  const [scrollMap, setScrollMap] = useState<boolean>(false)
  const [loadingBackup, setLoadingBackup] = useState<boolean>(false)
  const [modalImg, setModalImg] = useState<boolean>(false)
  const [modalTitle, setModalTitle] = useState<ModalExamDocTitle>({ title: t('BRANCH.INPUT.PDFINVOICEFEE'), page: ['TREATMENT'], example: PDFINVOICEFEE })
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [isAlertReceipt, setIsAlertReceipt] = useState(false)
  const [apptService, setApptService] = useState<string>("1")
  const [timeAppointment, setTimeAppointment] = useState<TIME_APPOINTMENT.CLINIC | TIME_APPOINTMENT.SCHEDULE>(TIME_APPOINTMENT.CLINIC)
  const [calculateAdvance, setCalculateAdvance] = useState<CALCULATE_ADVANCE.INCREASE | CALCULATE_ADVANCE.DECREASE>(CALCULATE_ADVANCE.INCREASE)
  const [patientCodeAll, setPatientCodeAll] = useState<PATIENT_CODE.CN | PATIENT_CODE.PT | PATIENT_CODE.SN>(PATIENT_CODE.CN)
  const [patientCodeQueue, setSettingQueue] = useState<PATIENT_CODE.CN | PATIENT_CODE.PT | PATIENT_CODE.SN>(PATIENT_CODE.CN)
  const [defaultDfReport, setDefaultDfReport] = useState<DEFAULT_DF_REPORT.PAY | DEFAULT_DF_REPORT.OP>(DEFAULT_DF_REPORT.PAY)
  const [defaultDfCon, setDefaultDfCon] = useState<DEFAULT_DF_CON.PAY_1 | DEFAULT_DF_CON.PAY_2 | DEFAULT_DF_CON.PAY_3 | DEFAULT_DF_CON.PAY_4 | DEFAULT_DF_CON.PAY_5>(DEFAULT_DF_CON.PAY_1)
  const [showOperativeCode, setShowOperativeCode] = useState<CODE_OPERATIVE.SHOW | CODE_OPERATIVE.NOT_DISPLAYED>(CODE_OPERATIVE.NOT_DISPLAYED)
  const [showAppointmentSharing, setShowAppointmentSharing] = useState<APPOINTMENT_SHARING.SHOW | APPOINTMENT_SHARING.NOT_DISPLAYED>(APPOINTMENT_SHARING.NOT_DISPLAYED)
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  useEffect(() => {
    setSettingQueue(patientCodeAll)
    setSettingAppointment(patientCodeAll)
    setSettingLab(patientCodeAll)
  }, [patientCodeAll])

  const handleSnCode = useCallback(() => {
    const fetchData = async () => {
      const sn = await UseSnCode()
      setSnType(sn)
    }

    fetchData()
  }, [snType])

  useEffect(() => {
    handleSnCode()
  }, [])

  const dateOfWeek = [`Mon`, `Tue`, `Wed`, `Thu`, `Fri`, `Sat`, `Sun`]
  const loadBranches = useCallback(() => {
    setInitLocation(location)
    if (!banks.length) BanksApi.findAll({ pageLimit: 50, status: 'ACTIVE' }).then(({ data }) => data && setBanks(data))
    if (!servicePoints.length) ServicePointApi.findAll({ pageLimit: 100, status: 'ACTIVE' }).then(({ data }) => data && setServicePoint(data))
    const { state }: any = initLocation
    setEditData(state)
    if (editData?.branchId) onEdit()
  }, [location, banks, servicePoints, initLocation])

  const loadCountries = () => {
    ComponentApi.findAllCountries().then(({ data }) => data && setCountryOptions(data))
  }

  useEffect(() => {
    loadCountries()
  }, [])

  useEffect(() => {
    loadBranches()
  }, [loadBranches])

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const onEdit = () => {
    const {
      branchId,
      branchCode,
      branchAddress,
      branchAddressEn,
      branchEmail,
      branchFacebook,
      branchFax,
      branchInstagram,
      branchLicense,
      branchLine,
      branchName,
      branchNameEn,
      hospitalName,
      hospitalCode,
      branchNumber,
      branchPhone,
      branchTax,
      branchTel,
      branchWebsite,
      countryId,
      districtId,
      postcode,
      provinceId,
      hasRecieptAddress,
      receiptAddress,
      receiptAddressEn,
      receiptCountryId,
      receiptProvinceId,
      receiptDistrictId,
      receiptSubDistrictId,
      receiptPostcode,
      subDistrictId,
      defaultReceipt,
      defaultReceiptRemarkStatus,
      defaultReceiptPracticeStatus,
      thermalFormat,
      receiptNumberPrefix,
      thermalRemark,
      branchServicePoints,
      officeTimes,
      bankAccounts,
      branch_logo,
      branch_image,
      branch_logo_thermal,
      opdCard,
      opdCardCover,
      opdCardBlank,
      opdCardHospital,
      dentistCertificate,
      dentistCertificateBlank,

      showCostEstimateReceipt,

      receiptA5Default,
      receiptA5Original,
      receiptA5Copy,
      receiptA5DefaultEn,
      receiptA5OriginalEn,
      receiptA5CopyEn,
      receiptA5DefaultLandscape,
      receiptA5OriginalLandscape,
      receiptA5CopyLandscape,
      receiptA5DfLscape,
      receiptA5DfOrgLscape,
      receiptA5DfCopyLscape,
      receiptA4Default,
      receiptA4Original,
      receiptA4Copy,
      receiptThermal,
      receiptThermalDf,

      receiptA5FixDfLscape,
      receiptA5FixDfOrgLscape,
      receiptA5FixDfCopyLscape,

      drugSticker,
      doctorCertificate,
      doctorCertificateFor5Diseases,
      driverLicenseDoctorCertificate,
      doctorCertificateA5,

      pdfInvoice,
      pdfInvoiceTreatment,
      pdfInvoiceTreatmentCondition,

      outStandingPayment,

      referralPatient,
      referralPatientBlank,
      dentalReferral,
      opdCardForPrint,
      socialSecurityCertificate,
      medicalServiceUsageForm,

      patientCodeQueue,
      patientCodeAppointment,
      patientCodeLab,
      stickerFormat,

      defaultDfReport,
      defaultDfCon,
      addressMap,

      opdCardBlank2,
      dentistCertificateEn,
      dentistCertificateBlankEn,
      doctorCertificateFor5DiseasesEn,
      doctorCertificateFor5DiseasesBlank,
      doctorCertificateFor5DiseasesBlankEn,
      driverLicenseDoctorCertificateEn,
      driverLicenseDoctorCertificateBlank,
      driverLicenseDoctorCertificateBlankEn,
      doctorCertificateA5En,
      doctorCertificateA5Blank,
      doctorCertificateA5BlankEn,

      opdCardFirst,
      opdCardAppointment,

      formRegister,
      timeAppointment,
      apptService,
      showOperativeCode,
      showAppointmentSharing,
      calculateAdvance,
      qrCodeReceiptDetail,
      qrCodeReceipt

    } = editData
    setBranchId(Number(branchId))
    setBranchCode(branchCode)
    setBranchNumber(branchNumber)
    setBranchName(branchName)
    setBranchNameEn(branchNameEn)
    setHospitalName(hospitalName)
    setHospitalCode(hospitalCode)
    setBranchLicense(branchLicense)
    setBranchTax(branchTax)
    setBranchPhone(branchPhone)
    setBranchTel(branchTel)
    setBranchFax(branchFax)
    setBranchLine(branchLine)
    setBranchWebsite(branchWebsite)
    setBranchEmail(branchEmail)
    setBranchFacebook(branchFacebook)
    setBranchInstagram(branchInstagram)
    setBranchAddress(branchAddress)
    setBranchAddressEn(branchAddressEn)
    setDefaultReceipt(defaultReceipt)
    setDefaultReceiptRemarkStatus(defaultReceiptRemarkStatus)
    setDefaultReceiptPracticeStatus(defaultReceiptPracticeStatus)
    setThermalFormat(thermalFormat)
    setReceiptNumberPrefix(receiptNumberPrefix)
    setThermalRemark(thermalRemark)
    setAddressRecieptSameBranch(hasRecieptAddress === '1')
    setRecieptAddress(receiptAddress)
    setRecieptAddressEn(receiptAddressEn)
    setCountry(countryId)
    setRecieptCountry(receiptCountryId)
    setOpdCard(opdCard === '1')
    setOpdCardCover(opdCardCover === '1')
    setOpdCardBlank(opdCardBlank === '1')
    setOpdCardHospital(opdCardHospital === '1')
    setDentistCertificate(dentistCertificate === '1')
    setDentistCertificateBlank(dentistCertificateBlank === '1')

    setShowCostEstimateReceipt(showCostEstimateReceipt)

    setReceiptA5Default(true)
    setReceiptA5Original(receiptA5Original === '1')
    setReceiptA5Copy(receiptA5Copy === '1')
    setReceiptA5DefaultEn(receiptA5DefaultEn === '1')
    setReceiptA5OriginalEn(receiptA5OriginalEn === '1')
    setReceiptA5CopyEn(receiptA5CopyEn === '1')
    setReceiptA5DefaultLandscape(receiptA5DefaultLandscape === '1')
    setReceiptA5OriginalLandscape(receiptA5OriginalLandscape === '1')
    setReceiptA5CopyLandscape(receiptA5CopyLandscape === '1')
    setReceiptA5DfLscape(receiptA5DfLscape === '1')
    setReceiptA5DfOrgLscape(receiptA5DfOrgLscape === '1')
    setReceiptA5DfCopyLscape(receiptA5DfCopyLscape === '1')
    setReceiptA4Default(true)
    setReceiptA4Original(receiptA4Original === '1')
    setReceiptA4Copy(receiptA4Copy === '1')
    setReceiptThermal(true)
    setReceiptThermalDf(receiptThermalDf === '1')

    setReceiptA5FixDfLscape(receiptA5FixDfLscape === '1')
    setReceiptA5FixDfOrgLscape(receiptA5FixDfOrgLscape === '1')
    setReceiptA5FixDfCopyLscape(receiptA5FixDfCopyLscape === '1')

    setDrugSticker(drugSticker === '1')
    setDoctorCertificate(doctorCertificate === '1')
    setDoctorCertificateFor5Diseases(doctorCertificateFor5Diseases === '1')
    setDriverLicenseDoctorCertificate(driverLicenseDoctorCertificate === '1')
    setDoctorCertificateA5(doctorCertificateA5 === '1')

    setPdfInvoice(pdfInvoice === '1')
    setPdfInvoiceTreatment(pdfInvoiceTreatment === '1')
    setPdfInvoiceTreatmentCondition(pdfInvoiceTreatmentCondition || '0')

    setOutStandingPayment(outStandingPayment === '1')

    setReferralPatient(referralPatient === '1')
    setReferralPatientBlank(referralPatientBlank === '1')
    setDentalReferral(dentalReferral === '1')
    setOpdCardForPrint(opdCardForPrint === '1')
    setSocialSecurityCertificate(socialSecurityCertificate === '1')
    setMedicalServiceUsageForm(medicalServiceUsageForm === '1')

    setPatientCodeAll(patientCodeQueue)
    // setSettingQueue(patientCodeQueue)
    // setSettingAppointment(patientCodeAppointment)
    // setSettingLab(patientCodeLab)

    setStickerFormat(stickerFormat)

    setDefaultDfReport(defaultDfReport)
    setDefaultDfCon(defaultDfCon)
    setAddressMap(addressMap)

    setOpdCardBlank2(opdCardBlank2 === '1')
    setDentistCertificateEn(dentistCertificateEn === '1')
    setDentistCertificateBlankEn(dentistCertificateBlankEn === '1')
    setDoctorCertificateFor5DiseasesEn(doctorCertificateFor5DiseasesEn === '1')
    setDoctorCertificateFor5DiseasesBlankEn(doctorCertificateFor5DiseasesBlankEn === '1')
    setDoctorCertificateFor5DiseasesBlank(doctorCertificateFor5DiseasesBlank === '1')
    setDriverLicenseDoctorCertificateEn(driverLicenseDoctorCertificateEn === '1')
    setDriverLicenseDoctorCertificateBlank(driverLicenseDoctorCertificateBlank === '1')
    setDriverLicenseDoctorCertificateBlankEn(driverLicenseDoctorCertificateBlankEn === '1')
    setDoctorCertificateA5En(doctorCertificateA5En === '1')
    setDoctorCertificateA5Blank(doctorCertificateA5Blank === '1')
    setDoctorCertificateA5BlankEn(doctorCertificateA5BlankEn === '1')
    setTimeAppointment(timeAppointment)
    setApptService(apptService || "1")
    setCalculateAdvance(calculateAdvance)
    setShowOperativeCode(showOperativeCode)
    setShowAppointmentSharing(showAppointmentSharing)
    setQRCodeReceiptDetail(qrCodeReceiptDetail || '')
    setQRCodeReceipt(qrCodeReceipt || objImage)

    setOpdCardFirst(opdCardFirst === '1')
    setOpdCardAppointment(opdCardAppointment === '1')

    if (qrCodeReceipt) {
      const { fileId, filePath, fileName }: any = qrCodeReceipt
      setImgQRData(`${fileUrl}/${filePath}/${fileName}`)
    }


    const form = JSON.parse(formRegister)
    setFormRegister(form)
    const formAp = editData.formAppointment ? JSON.parse(editData.formAppointment) : []
    setFormAppointment(formAp)


    //  if (subDistrictId) {
    setBranchSelectAddress({ province_id: provinceId, district_id: districtId, sub_district_id: subDistrictId, postcode: postcode })
    //  }
    if (receiptSubDistrictId) {
      setRecieptSelectAddress({ province_id: receiptProvinceId, district_id: receiptDistrictId, sub_district_id: receiptSubDistrictId, postcode: receiptPostcode })
    }
    if (branchServicePoints.length) {
      const tempBSP = branchServicePoints.map((bsp: any) => {
        return {
          servicePointId: bsp.servicePointId
        }
      })
      setBranchServicePoints(tempBSP)
    }
    if (officeTimes.length) {
      const tempOfficeTime: any = []
      for (const officeTime in officeTimes) {
        if (Object.prototype.hasOwnProperty.call(officeTimes, officeTime)) {
          const ot: any = officeTimes[officeTime]
          if (!tempOfficeTime.find((tt: any) => tt.timeStart === ot.timeIn && tt.timeEnd === ot.timeOut)) {
            const search = officeTimes.filter((officeT: any) => officeT.timeIn === ot.timeIn && officeT.timeOut === ot.timeOut && officeT.timeType === ot.timeType)
            tempOfficeTime.push({
              timeStart: ot.timeIn,
              timeEnd: ot.timeOut,
              typetime: ot.officeStatus,
              days: {
                sun: search.find((officeT: any) => officeT.dayOfWeek === 'Sun') ? true : false,
                mon: search.find((officeT: any) => officeT.dayOfWeek === 'Mon') ? true : false,
                tue: search.find((officeT: any) => officeT.dayOfWeek === 'Tue') ? true : false,
                wed: search.find((officeT: any) => officeT.dayOfWeek === 'Wed') ? true : false,
                thu: search.find((officeT: any) => officeT.dayOfWeek === 'Thu') ? true : false,
                fri: search.find((officeT: any) => officeT.dayOfWeek === 'Fri') ? true : false,
                sat: search.find((officeT: any) => officeT.dayOfWeek === 'Sat') ? true : false
              }
            })
          }
        }
      }
      setBranchTimes(tempOfficeTime)
    }
    if (bankAccounts.length) {
      let tempBranchBanks: any = []
      _.map(bankAccounts, (ba: any) => {
        if (
          _.get(
            banks.find((b: any) => b.bankId === ba.bankId),
            'bankName'
          )
        ) {
          tempBranchBanks = [
            ...tempBranchBanks,
            {
              bankId: ba.bankId,
              bankName:
                _.get(
                  banks.find((b: any) => b.bankId === ba.bankId),
                  'bankName'
                ) || '',
              bankAccountName: ba.bankAccountName,
              bankAccountNumber: ba.bankAccountNumber,
              hasTransfer: banks.find((b: any) => b.bankId === ba.bankId && b.hasTransfer === 'SUPPORT')
                ? ba.hasTransfer
                : _.get(
                  banks.find((b: any) => b.bankId === ba.bankId),
                  'hasTransfer'
                ),
              hasCredit: banks.find((b: any) => b.bankId === ba.bankId && b.hasCredit === 'SUPPORT')
                ? ba.hasCredit
                : _.get(
                  banks.find((b: any) => b.bankId === ba.bankId),
                  'hasCredit'
                ),
              hasDebit: banks.find((b: any) => b.bankId === ba.bankId && b.hasDebit === 'SUPPORT')
                ? ba.hasDebit
                : _.get(
                  banks.find((b: any) => b.bankId === ba.bankId),
                  'hasCredit'
                ),
              disabledTransfer: banks.find((b: any) => b.bankId === ba.bankId && b.hasTransfer === 'SUPPORT') ? false : true,
              disabledCredit: banks.find((b: any) => b.bankId === ba.bankId && b.hasCredit === 'SUPPORT') ? false : true,
              disabledDebit: banks.find((b: any) => b.bankId === ba.bankId && b.hasDebit === 'SUPPORT') ? false : true
            }
          ]
        }
      })
      setBranchBanks(tempBranchBanks)
    }
    if (branch_logo) {
      const { fileId, filePath, fileName }: any = branch_logo
      setBranchLogoData(`${fileUrl}/${filePath}/${fileName}`)
      setBranchLogo({ fileId: fileId, base64: '', fileExtension: '', fileSize: '' })
    }
    if (branch_image) {
      const { fileId, filePath, fileName }: any = branch_image
      setBranchImageDataId(fileId)
      setBranchImageData(`${fileUrl}/${filePath}/${fileName}`)
      setBranchImage({ fileId: fileId, base64: '', fileExtension: '', fileSize: '' })
    }
    if (branch_logo_thermal) {
      const { fileId, filePath, fileName }: any = branch_logo_thermal
      setBranchLogoThermalDataId(fileId)
      setBranchLogoThermalData(`${fileUrl}/${filePath}/${fileName}`)
      setBranchLogoThermal({ fileId: fileId, base64: '', fileExtension: '', fileSize: '' })
    }
  }

  const submitUpdate = () => {
    let checkError = false
    let errorMsg = { ...errorMessage }
    if (!branchCode || !branchNumber || !branchName || !branchPhone) {
      checkError = true
      setBranchTab('INFORMATION')
      notiError(t('BRANCH.MESSAGE.ERROR_MESSAGE.BRANCH'))
      errorMsg = {
        ...errorMsg,
        BRANCH_CODE: !branchCode ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.BRANCH_CODE`) : '',
        BRANCH_NUMBER: !branchNumber ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.BRANCH_NUMBER`) : '',
        BRANCH_NAME: !branchName ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.BRANCH_NAME`) : '',
        BRANCH_PHONE: !branchPhone ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.BRANCH_PHONE`) : ''
      }
    }

    if (_.some(branchBanks, (bank, index) => !bank.bankAccountName) || _.some(branchBanks, (bank, index) => !bank.bankAccountNumber)) {
      //  notiError(t('BRANCH.MESSAGE.ERROR_MESSAGE.BANK'))
      if (!checkError) setBranchTab('BANK')
      checkError = true
      errorMsg = {
        ...errorMsg,
        EMPTY_BANK_ACCOUNT_NAME: _.some(branchBanks, (bank, index) => !bank.bankAccountName) ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.EMPTY_BANK_ACCOUNT_NAME`) : '',
        EMPTY_BANK_ACCOUNT_NUMBER: _.some(branchBanks, (bank, index) => !bank.bankAccountNumber) ? t(`BRANCH.MESSAGE.ERROR_MESSAGE.EMPTY_BANK_ACCOUNT_NUMBER`) : ''
      }
    }

    let branchServicePoint: any = []
    _.map(servicePoints, (i, index) => {
      if (_.some(branchServicePoints, (j) => j.servicePointId === i.servicePointId)) branchServicePoint = [...branchServicePoint, i]
    })

    if (_.some(branchServicePoint, (service) => service.pointOfService === 'PAYMENT') === false) {
      errorMsg = {
        ...errorMsg,
        SERVICE_POINT: 'กรุณาเลือกจุดบริการ'
      }
      notiError(t('BRANCH.MESSAGE.NOT_FOUND_PAYMENT'))
      if (!checkError) setBranchTab('SERVICE_POINT')
      checkError = true
    } else if (!canAddServicePoint) {
      errorMsg = {
        ...errorMsg,
        SERVICE_POINT: 'กรุณาเลือกจุดบริการ'
      }
      if (!checkError) setBranchTab('SERVICE_POINT')
      checkError = true
    }


    if (!branchTimes?.length) {
      errorMsg = {
        ...errorMsg,
        WORK_TIME_LIST: t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME_LIST`),
      }
      if (!checkError) setBranchTab('WORK_TIME')
      checkError = true
    }

    const sun = branchTimes.filter((bt) => Boolean(bt.days.sun) === true)
    const mon = branchTimes.filter((bt) => Boolean(bt.days.mon) === true)
    const tue = branchTimes.filter((bt) => Boolean(bt.days.tue) === true)
    const wed = branchTimes.filter((bt) => Boolean(bt.days.wed) === true)
    const thu = branchTimes.filter((bt) => Boolean(bt.days.thu) === true)
    const fri = branchTimes.filter((bt) => Boolean(bt.days.fri) === true)
    const sat = branchTimes.filter((bt) => Boolean(bt.days.sat) === true)


    if (_.isEmpty(sun) || _.isEmpty(mon) || _.isEmpty(tue) || _.isEmpty(wed) || _.isEmpty(thu) || _.isEmpty(fri) || _.isEmpty(sat)) {
      errorMsg = {
        ...errorMsg,
        WORK_TIME: t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME`),
      }
      notiError(t('BRANCH.MESSAGE.ERROR_MESSAGE.DATE_NOT_COMPLETE'))
      if (!checkError) setBranchTab('WORK_TIME')
      checkError = true
    }

    if (_.size(sun) > 1 || _.size(mon) > 1 || _.size(tue) > 1 || _.size(wed) > 1 || _.size(thu) > 1 || _.size(fri) > 1 || _.size(sat) > 1) {
      errorMsg = {
        ...errorMsg,
        WORK_TIME: t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME`),
      }
      //  notiError(t('BRANCH.MESSAGE.ERROR_MESSAGE.DATE_ALREADY_SELECT'))
      if (!checkError) setBranchTab('WORK_TIME')
      checkError = true
    }

    if (_.some(branchTimes, d => d.typetime === 'CLOSE' && _.every(d.days))) {
      errorMsg = {
        ...errorMsg,
        WORK_TIME: t(`BRANCH.MESSAGE.ERROR_MESSAGE.WORK_TIME`),
      }
      notiError(t('กรุณาเลือกที่วันทำการ'))
      if (!checkError) setBranchTab('WORK_TIME')
      checkError = true
    }


    if (checkError) {
      setErrorMessage((per) => ({ ...errorMsg }))
      return
    }

    const branchOfficeTimes: BranchOfficeTimesInterface[] = [
      { dayOfWeek: 'sun', timeIn: sun[0].timeStart, timeOut: sun[0].timeEnd, officeStatus: sun[0].typetime },
      { dayOfWeek: 'mon', timeIn: mon[0].timeStart, timeOut: mon[0].timeEnd, officeStatus: mon[0].typetime },
      { dayOfWeek: 'tue', timeIn: tue[0].timeStart, timeOut: tue[0].timeEnd, officeStatus: tue[0].typetime },
      { dayOfWeek: 'wed', timeIn: wed[0].timeStart, timeOut: wed[0].timeEnd, officeStatus: wed[0].typetime },
      { dayOfWeek: 'thu', timeIn: thu[0].timeStart, timeOut: thu[0].timeEnd, officeStatus: thu[0].typetime },
      { dayOfWeek: 'fri', timeIn: fri[0].timeStart, timeOut: fri[0].timeEnd, officeStatus: fri[0].typetime },
      { dayOfWeek: 'sat', timeIn: sat[0].timeStart, timeOut: sat[0].timeEnd, officeStatus: sat[0].typetime }
    ]

    const dataCheckReceipt: { [key: string]: boolean } = {
      "A4_ORI": receiptA4Original,
      "A4_COPY": receiptA4Copy,
      "A5_ORI": receiptA5Original,
      "A5_COPY": receiptA5Copy,
      "A5_EN": receiptA5DefaultEn,
      "A5_EN_ORI": receiptA5OriginalEn,
      "A5_EN_COPY": receiptA5CopyEn,
      "A5_LANDSCAPE_NORMAL": receiptA5DefaultLandscape,
      "A5_LANDSCAPE_NORMAL_ORI": receiptA5OriginalLandscape,
      "A5_LANDSCAPE_NORMAL_COPY": receiptA5CopyLandscape,
      "A5_LANDSCAPE": receiptA5DfLscape,
      "A5_LANDSCAPE_ORI": receiptA5DfOrgLscape,
      "A5_LANDSCAPE_COPY": receiptA5DfCopyLscape,
      "A5_LANDSCAPE_DF": receiptA5FixDfLscape,
      "A5_LANDSCAPE_DF_ORI": receiptA5FixDfOrgLscape,
      "A5_LANDSCAPE_DF_COPY": receiptA5FixDfCopyLscape
    }

    const checkReceipt = dataCheckReceipt[defaultReceipt] !== undefined ? dataCheckReceipt[defaultReceipt] : true

    if (!checkReceipt && !isAlertReceipt) {
      setIsOpenAlertModal(true)
      setIsAlertReceipt(true)
      return
    }

    const objUpdate = {
      branchCode: branchCode,
      branchNumber: branchNumber,
      branchName: branchName,
      branchNameEn: branchNameEn,
      hospitalName: hospitalName,
      hospitalCode: hospitalCode,
      branchEmail: branchEmail,
      branchTel: branchTel,
      branchPhone: branchPhone,
      branchFax: branchFax,
      branchTax: branchTax,
      branchLicense: branchLicense,
      branchFacebook: branchFacebook,
      branchLine: branchLine,
      branchInstagram: branchInstagram,
      branchWebsite: branchWebsite,
      defaultReceipt: checkReceipt ? defaultReceipt : 'A5',
      defaultReceiptRemarkStatus: defaultReceiptRemarkStatus,
      defaultReceiptPracticeStatus: defaultReceiptPracticeStatus,
      thermalFormat: thermalFormat,
      receiptNumberPrefix: receiptNumberPrefix,
      thermalRemark: thermalRemark,
      branchAddress: branchAddress,
      branchAddressEn: branchAddressEn,
      countryId: country,
      provinceId: branchSelectAddress?.province_id,
      districtId: branchSelectAddress?.district_id,
      subDistrictId: branchSelectAddress?.sub_district_id,
      postcode: String(branchSelectAddress?.postcode),
      branchFullAddress: '',
      branchFullAddressEn: '',
      latitude: branchSelectAddress?.latitude,
      longitude: branchSelectAddress?.longtitude,
      opdCard: opdCard ? '1' : '0',
      opdCardCover: opdCardCover ? '1' : '0',
      opdCardBlank: opdCardBlank ? '1' : '0',
      opdCardHospital: opdCardHospital ? '1' : '0',
      dentistCertificate: dentistCertificate ? '1' : '0',

      showCostEstimateReceipt: showCostEstimateReceipt,

      receiptA5Default: receiptA5Default ? '1' : '0',
      receiptA5Original: receiptA5Original ? '1' : '0',
      receiptA5Copy: receiptA5Copy ? '1' : '0',
      receiptA5DefaultEn: receiptA5DefaultEn ? '1' : '0',
      receiptA5OriginalEn: receiptA5OriginalEn ? '1' : '0',
      receiptA5CopyEn: receiptA5CopyEn ? '1' : '0',
      receiptA5DefaultLandscape: receiptA5DefaultLandscape ? '1' : '0',
      receiptA5OriginalLandscape: receiptA5OriginalLandscape ? '1' : '0',
      receiptA5CopyLandscape: receiptA5CopyLandscape ? '1' : '0',
      receiptA5DfLscape: receiptA5DfLscape ? "1" : "0",
      receiptA5DfOrgLscape: receiptA5DfOrgLscape ? "1" : "0",
      receiptA5DfCopyLscape: receiptA5DfCopyLscape ? "1" : "0",
      receiptA4Default: receiptA4Default ? '1' : '0',
      receiptA4Original: receiptA4Original ? '1' : '0',
      receiptA4Copy: receiptA4Copy ? '1' : '0',
      receiptThermal: receiptThermal ? '1' : '0',
      receiptThermalDf: receiptThermalDf ? '1' : '0',

      receiptA5FixDfLscape: receiptA5FixDfLscape ? '1' : '0',
      receiptA5FixDfOrgLscape: receiptA5FixDfOrgLscape ? '1' : '0',
      receiptA5FixDfCopyLscape: receiptA5FixDfCopyLscape ? '1' : '0',

      drugSticker: drugSticker ? '1' : '0',
      doctorCertificate: doctorCertificate ? '1' : '0',
      doctorCertificateFor5Diseases: doctorCertificateFor5Diseases ? '1' : '0',
      driverLicenseDoctorCertificate: driverLicenseDoctorCertificate ? '1' : '0',
      doctorCertificateA5: doctorCertificateA5 ? '1' : '0',

      pdfInvoice: pdfInvoice ? '1' : '0',
      pdfInvoiceTreatment: pdfInvoiceTreatment ? '1' : '0',
      pdfInvoiceTreatmentCondition: pdfInvoiceTreatmentCondition,

      outStandingPayment: outStandingPayment ? '1' : '0',

      referralPatient: referralPatient ? '1' : '0',
      referralPatientBlank: referralPatientBlank ? '1' : '0',
      dentalReferral: dentalReferral ? '1' : '0',
      opdCardForPrint: opdCardForPrint ? '1' : '0',
      socialSecurityCertificate: socialSecurityCertificate ? '1' : '0',
      medicalServiceUsageForm: medicalServiceUsageForm ? '1' : '0',

      dentistCertificateBlank: dentistCertificateBlank ? '1' : '0',
      hasRecieptAddress: addressRecieptSameBranch ? '1' : '0',
      receiptAddress: !addressRecieptSameBranch ? receiptAddress : '',
      receiptAddressEn: !addressRecieptSameBranch ? receiptAddressEn : '',
      receiptCountryId: !addressRecieptSameBranch ? receiptCountry : null,
      receiptProvinceId: !addressRecieptSameBranch ? receiptSelectAddress?.province_id : null,
      receiptDistrictId: !addressRecieptSameBranch ? receiptSelectAddress?.district_id : null,
      receiptSubDistrictId: !addressRecieptSameBranch ? receiptSelectAddress?.sub_district_id : null,
      receiptPostcode: !addressRecieptSameBranch ? String(receiptSelectAddress?.postcode) : null,
      receiptFullAddress: null,
      receiptFullAddressEn: null,
      timeIn: '',
      timeOut: '',
      status: 'ACTIVE',
      branchServicePoints: branchServicePoints,
      branchOfficeTimes: branchOfficeTimes,
      branchBankAccounts: _.map(branchBanks, (bBank: any) => {
        if (bBank.bankId) {
          return {
            bankId: bBank.bankId,
            bankAccountName: bBank.bankAccountName,
            bankAccountNumber: bBank.bankAccountNumber,
            hasTransfer: bBank.hasTransfer === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT',
            hasCredit: bBank.hasCredit === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT',
            hasDebit: bBank.hasDebit === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT'
          }
        }
      }),

      patientCodeQueue: patientCodeQueue,
      patientCodeAppointment: patientCodeAppointment,
      patientCodeLab: patientCodeLab,
      stickerFormat: stickerFormat,

      defaultDfReport: defaultDfReport,
      defaultDfCon: defaultDfCon,
      addressMap: addressMap,

      opdCardBlank2: opdCardBlank2 ? '1' : '0',
      dentistCertificateEn: dentistCertificateEn ? '1' : '0',
      dentistCertificateBlankEn: dentistCertificateBlankEn ? '1' : '0',
      doctorCertificateFor5DiseasesEn: doctorCertificateFor5DiseasesEn ? '1' : '0',
      doctorCertificateFor5DiseasesBlankEn: doctorCertificateFor5DiseasesBlankEn ? '1' : '0',
      doctorCertificateFor5DiseasesBlank: doctorCertificateFor5DiseasesBlank ? '1' : '0',
      driverLicenseDoctorCertificateEn: driverLicenseDoctorCertificateEn ? '1' : '0',
      driverLicenseDoctorCertificateBlank: driverLicenseDoctorCertificateBlank ? '1' : '0',
      driverLicenseDoctorCertificateBlankEn: driverLicenseDoctorCertificateBlankEn ? '1' : '0',
      doctorCertificateA5En: doctorCertificateA5En ? '1' : '0',
      doctorCertificateA5Blank: doctorCertificateA5Blank ? '1' : '0',
      doctorCertificateA5BlankEn: doctorCertificateA5BlankEn ? '1' : '0',
      formRegister: JSON.stringify(formRegister),
      formAppointment: JSON.stringify(formAppointment),
      timeAppointment,
      apptService,
      showOperativeCode,
      showAppointmentSharing,
      calculateAdvance,
      qrCodeReceiptDetail,
      qrCodeReceipt,

      opdCardFirst: opdCardFirst ? '1' : '0',
      opdCardAppointment: opdCardAppointment ? '1' : '0'
    }

    const objValidate = JSON.parse(JSON.stringify(objUpdate, (key, value) => (value === undefined || value === 'undefined' ? '' : value)))
    objValidate.branch_logo = branchLogo
    objValidate.branch_image = branchImage
    objValidate.branchLogoThermal = branchLogoThermal
    setDisabledSubmit(true)
    BranchApi.update(branchId, objValidate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          // localStorage.setItem(KEY_STORAGE.CLINIC_INFO, JSON.stringify(objValidate))
          notiSuccess(t(`BRANCH.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
            return
          })
          history.push(routeName.branch)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`BRANCH.MESSAGE.${err.message}`) } })
        }
      })
      .catch((e) => {
        const err: any = e?.response?.data
        setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`BRANCH.MESSAGE.${err?.message}`) } })
      })
      .finally(() => {
        setLoading(false)
        setDisabledSubmit(false)
      })
  }

  const uploadBranchLogo = (files: any) => {
    if (files[0]) {
      /**
       * files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const file = files[0]
      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        /** reader.result is base64 */
        const base64 = reader.result.split(',')
        setBranchLogoData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setBranchLogo(detailImage)
    }
  }
  const uploadBranchLogoThermal = (files: any) => {
    if (files[0] || files?.target?.files[0]) {
      /**
       * files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const file = files[0] || files?.target?.files[0]
      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        /** reader.result is base64 */
        const base64 = reader.result.split(',')
        setBranchLogoThermalData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setBranchLogoThermal(detailImage)
      setBranchLogoThermalDataId(0)
    }
  }

  const uploadBranchImage = (files: any) => {
    if (files[0] || files?.target?.files[0]) {
      /**
       * files all detail file
       * lastModified, lastModifiedDate
       * name, size, type
       */
      const file = files[0] || files?.target?.files[0]
      const fileName = file.name.split('.')
      const detailImage = {
        fileId: null,
        base64: '',
        fileExtension: fileName[fileName.length - 1],
        fileSize: file.size.toString()
      }
      const reader: any = new FileReader()
      reader.addEventListener('load', () => {
        /** reader.result is base64 */
        const base64 = reader.result.split(',')
        setBranchImageData(reader.result)
        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result
      })
      reader.readAsDataURL(file)
      setBranchImage(detailImage)
      setBranchImageDataId(0)
    }
  }

  const handleChangeBranchTimeType = (value: string, index: number) => {
    const branchTimeTemp: any = [...branchTimes]
    branchTimeTemp[index].typetime = value
    setBranchTimes(branchTimeTemp)
  }

  const handleChangeBranchTimeDate = (day: string, index: number) => {
    const branchTimeTemp: any = [...branchTimes]
    branchTimeTemp[index].days[day] = !branchTimeTemp[index].days[day]
    setBranchTimes(branchTimeTemp)
  }

  const handleChangeBranchTime = (times: any, index: number) => {
    const branchTimeTemp: any = [...branchTimes]
    branchTimeTemp[index].timeStart = times[0]
    branchTimeTemp[index].timeEnd = times[1]
    setBranchTimes(branchTimeTemp)
  }

  const addBranchTime = () => setBranchTimes([...branchTimes, ...objBranchTime])

  const deleteBranchTime = (e: any, index: number) => {
    const branchTimeTemp: any = []
    for (const iBt in branchTimes) {
      if (Object.prototype.hasOwnProperty.call(branchTimes, iBt)) {
        const element = branchTimes[iBt]
        if (Number(iBt) !== Number(index)) branchTimeTemp.push(element)
      }
    }
    setBranchTimes(branchTimeTemp)
    setErrorMessage((pre) => ({ ...pre, WORK_TIME: '' }))
  }
  const handleChangeServicePoint = (servicePointId: number, index: number) => {
    const branchServicePointsTemp: any = [...branchServicePoints]
    branchServicePointsTemp[index].servicePointId = servicePointId
    setBranchServicePoints(branchServicePointsTemp)
  }

  const canAddServicePoint = branchServicePoints.every(bp => bp.servicePointId !== 0);


  const addBranchServicePoint = () => {
    if (!canAddServicePoint) return;
    setBranchServicePoints([
      ...branchServicePoints,
      ...objBranchServicePoint,
    ]);
    setErrorMessage({ ...errorMessage, "SERVICE_POINT": '' })
  };


  const deleteBranchServicePoint = (e: any, index: number) => {
    const branchServicePointsTemp: any = []
    for (const iBsp in branchServicePoints) {
      if (Object.prototype.hasOwnProperty.call(branchServicePoints, iBsp)) {
        const element = branchServicePoints[iBsp]
        if (Number(iBsp) !== Number(index)) branchServicePointsTemp.push(element)
      }
    }
    setBranchServicePoints(branchServicePointsTemp)
  }

  const selectBank = (bankId: number) => {
    const useBank = branchBanks.find((branchBank) => branchBank.bankId === bankId)
    const objBank = banks.find((b) => Number(b.bankId) === bankId)
    if (useBank) {
      const tempBranchBanks: any = [...branchBanks].filter((branchBank) => branchBank.bankId !== bankId)
      setBranchBanks(tempBranchBanks)
    } else {
      if (objBank) {
        const tempBranchBanks: BranchBankInterface[] = [
          {
            bankId: Number(objBank.bankId),
            bankName: objBank.bankName,
            bankAccountName: '',
            bankAccountNumber: '',
            hasTransfer: objBank.hasTransfer === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT',
            hasCredit: objBank.hasCredit === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT',
            hasDebit: objBank.hasDebit === 'SUPPORT' ? 'SUPPORT' : 'NOT_SUPPORT',
            disabledTransfer: banks.find((b: any) => b.bankId === bankId && b.hasTransfer === 'SUPPORT') ? false : true,
            disabledCredit: banks.find((b: any) => b.bankId === bankId && b.hasCredit === 'SUPPORT') ? false : true,
            disabledDebit: banks.find((b: any) => b.bankId === bankId && b.hasDebit === 'SUPPORT') ? false : true
          }
        ]
        setBranchBanks([...branchBanks, ...tempBranchBanks])
      }
    }
  }
  const handleChangeBranchBank = (value: any, index: number, key: string) => {
    // clearErrorMessage()
    const branchBanksTemp: any = [...branchBanks]
    branchBanksTemp[index][key] = value
    setBranchBanks(branchBanksTemp)
  }

  const renderBankLogo = (bankId: number) => {
    const item = banks.find((b: any) => b.bankId === bankId)
    if (_.get(item, 'image')) {
      const image = _.get(item, 'image')
      return `${fileUrl}/${image.filePath}/${image.fileName}`
    } else if (_.get(item, 'bankLogo')) {
      return _.get(item, 'bankLogo')
    } else return ''
  }


  const onRenderMap = useCallback(() => {
    const check = ['<iframe', '</iframe>']
    return addressMap && addressMap.includes(check[0]) && addressMap.includes(check[1])
  }, [addressMap])

  useEffect(() => {
    const divInfo = document.querySelector('.INFORMATION')
    if (divInfo && scrollMap && onRenderMap()) {
      $('.content-tab').delay(500).animate({ scrollTop: divInfo.clientHeight }, 300)
    }
  }, [addressMap])

  const branchTabInfo = [
    {
      tabName: "INFORMATION",
      require: true,
      className: `${errorMessage.BRANCH_CODE || errorMessage.BRANCH_NUMBER || errorMessage.BRANCH_NAME || errorMessage.BRANCH_PHONE ? 'error' : ''}`,
    },
    {
      tabName: "RECIEVE_STICKER",
      style: {
        width: 'fit-content'
      }
    },
    {
      tabName: "TEMPLACE_DOC",
    },
    {
      tabName: "WORK_TIME",
      className: `${errorMessage.WORK_TIME || errorMessage.WORK_TIME_LIST ? 'error' : ''}`
    },
    {
      tabName: "SERVICE_POINT",
      className: `${errorMessage.SERVICE_POINT ? 'error' : ''}`
    },
    {
      tabName: "BANK",
      className: `${errorMessage.EMPTY_BANK_ACCOUNT_NAME || errorMessage.EMPTY_BANK_ACCOUNT_NUMBER ? 'error' : ''}`
    },
    {
      tabName: "FORMATFORM",
    },
    {
      tabName: "SENTTING",
      textName: t('BRANCH.TAB.SENTTING.TITLE')
    },
  ]

  const templaceDoc_Opd: FormTemplaceDocDentisInfo[] = [
    {
      docName: 'OPD_CARD_COVER',
      checked: opdCardCover,
      onChange: () => setOpdCardCover(!opdCardCover),
      example: OPD_CARD_COVER,
      page: ['REGISTER',]
    },
    {
      docName: 'OPD_CARD',
      checked: opdCardFirst,
      onChange: () => setOpdCardFirst(!opdCardFirst),
      example: [OPD_CARD_COVER_V1, OPD_CARD_V1],
      page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    // {
    //   docName: 'OPD_CARD',
    //   checked: opdCardForPrint,
    //   onChange: () => setOpdCardForPrint(!opdCardForPrint),
    //   example: OPD_CARD,
    //   page: ['REGISTER']
    // },
    {
      docName: 'OPD_CARD_HOSPITAL',
      checked: opdCardHospital,
      onChange: () => setOpdCardHospital(!opdCardHospital),
      example: [OPD_CARD_HOSPITAL_1, OPD_CARD_HOSPITAL_2],
      page: ['REGISTER']
    },
    {
      docName: 'OPD_CARD_BLANK_1',
      checked: opdCardBlank,
      onChange: () => setOpdCardBlank(!opdCardBlank),
      example: OPD_CARD_BLANK_1,
      page: ['REGISTER']
    },
    {
      docName: 'OPD_CARD_BLANK_2',
      checked: opdCardBlank2,
      onChange: () => setOpdCardBlank2(!opdCardBlank2),
      example: OPD_CARD_BLANK_2,
      page: ['REGISTER']
    },
    {
      docName: 'OPD_APPOINTMENT',
      checked: opdCardAppointment,
      onChange: () => setOpdCardAppointment(!opdCardAppointment),
      example: [OPD_CARD_APPOINTMENT],
      page: ['REGISTER', 'TREATMENTHISTORY']
    },
    // {
    //   docName: 'OPD_CARD_V1',
    //   checked: opdCardFirst,
    //   onChange: () => setOpdCardFirst(!opdCardFirst),
    //   example: [OPD_CARD_COVER_V1, OPD_CARD_V1],
    //   page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    // }
  ]

  const templaceDoc_Referral: FormTemplaceDocDentisInfo[] = [
    {
      docName: 'REFERRALPATIENT',
      checked: referralPatient,
      onChange: () => setReferralPatient(!referralPatient),
      example: REFERRALPATIENT,
      page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    // {
    //   docName: 'REFERRALPATIENTBLANK',
    //   checked: referralPatientBlank,
    //   onChange: () => setReferralPatientBlank(!referralPatientBlank),
    //   example: REFERRALPATIENTBLANK,
    //   page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    // },
    {
      docName: 'REFERRALPATIENTBLANK',
      checked: referralPatientBlank,
      onChange: () => setReferralPatientBlank(!referralPatientBlank),
      example: REFERRALPATIENTBLANK,
      page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DENTALREFERRAL',
      checked: dentalReferral,
      onChange: () => setDentalReferral(!dentalReferral),
      example: DENTALREFERRAL,
      page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
  ]

  const templaceDoc_DoctorCertificate: FormTemplaceDocDentisInfo[] = [
    {
      docName: 'DOCTORCERTIFICATE_FORM_TH',
      checked: doctorCertificate,
      onChange: () => setDoctorCertificate(!doctorCertificate),
      example: DENTISTCERTIFICATE,
      page: ['REGISTER', 'TREATMENT', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_FORM_EN',
      checked: dentistCertificateEn,
      onChange: () => setDentistCertificateEn(!dentistCertificateEn),
      example: DENTISTCERTIFICATE_EN,
      page: ['REGISTER', 'TREATMENT', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_FORM_BLANK_TH',
      checked: dentistCertificateBlank,
      onChange: () => setDentistCertificateBlank(!dentistCertificateBlank),
      example: DENTISTCERTIFICATE_BLANK,
      page: ['REGISTER']
    },
    {
      docName: 'DOCTORCERTIFICATE_FORM_BLANK_EN',
      checked: dentistCertificateBlankEn,
      onChange: () => setDentistCertificateBlankEn(!dentistCertificateBlankEn),
      example: DENTISTCERTIFICATE_BLANK_EN,
      page: ['REGISTER']
    },

    {
      docName: 'DOCTORCERTIFICATEFOR5DISEASES',
      checked: doctorCertificateFor5Diseases,
      onChange: () => setDoctorCertificateFor5Diseases(!doctorCertificateFor5Diseases),
      example: DOCTORCERTIFICATEFOR5DISEASES,
      page: ['REGISTER', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATEFOR5DISEASES_EN',
      checked: doctorCertificateFor5DiseasesEn,
      onChange: () => setDoctorCertificateFor5DiseasesEn(!doctorCertificateFor5DiseasesEn),
      example: DOCTORCERTIFICATEFOR5DISEASES_EN,
      page: ['REGISTER', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATEFOR5DISEASES_BLANK',
      checked: doctorCertificateFor5DiseasesBlank,
      onChange: () => setDoctorCertificateFor5DiseasesBlank(!doctorCertificateFor5DiseasesBlank),
      example: DOCTORCERTIFICATEFOR5DISEASES_BLANK,
      page: ['REGISTER', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATEFOR5DISEASES_EN_BLANK',
      checked: doctorCertificateFor5DiseasesBlankEn,
      onChange: () => setDoctorCertificateFor5DiseasesBlankEn(!doctorCertificateFor5DiseasesBlankEn),
      example: DOCTORCERTIFICATEFOR5DISEASES_EN_BLANK,
      page: ['REGISTER', 'TREATMENTHISTORY', 'PAYMENT']
    },

    {
      docName: 'DRIVERLICENSEDOCTORCERTIFICATE',
      checked: driverLicenseDoctorCertificate,
      onChange: () => setDriverLicenseDoctorCertificate(!driverLicenseDoctorCertificate),
      example: DRIVERLICENSEDOCTORCERTIFICATE,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DRIVERLICENSEDOCTORCERTIFICATE_EN',
      checked: driverLicenseDoctorCertificateEn,
      onChange: () => setDriverLicenseDoctorCertificateEn(!driverLicenseDoctorCertificateEn),
      example: DRIVERLICENSEDOCTORCERTIFICATE_EN,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DRIVERLICENSEDOCTORCERTIFICATE_BLANK',
      checked: driverLicenseDoctorCertificateBlank,
      onChange: () => setDriverLicenseDoctorCertificateBlank(!driverLicenseDoctorCertificateBlank),
      example: DRIVERLICENSEDOCTORCERTIFICATE_BLANK,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK',
      checked: driverLicenseDoctorCertificateBlankEn,
      onChange: () => setDriverLicenseDoctorCertificateBlankEn(!driverLicenseDoctorCertificateBlankEn),
      example: DRIVERLICENSEDOCTORCERTIFICATE_EN_BLANK,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_A5',
      checked: doctorCertificateA5,
      onChange: () => setDoctorCertificateA5(!doctorCertificateA5),
      example: DENTISTCERTIFICATEA5,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_A5_EN',
      checked: doctorCertificateA5En,
      onChange: () => setDoctorCertificateA5En(!doctorCertificateA5En),
      example: DENTISTCERTIFICATEA5_EN,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_A5_BLANK',
      checked: doctorCertificateA5Blank,
      onChange: () => setDoctorCertificateA5Blank(!doctorCertificateA5Blank),
      example: DENTISTCERTIFICATEA5_BLANK,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'DOCTORCERTIFICATE_A5_EN_BLANK',
      checked: doctorCertificateA5BlankEn,
      onChange: () => setDoctorCertificateA5BlankEn(!doctorCertificateA5BlankEn),
      example: DOCTORCERTIFICATE_A5_EN_BLANK,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
  ]

  const templaceDoc_Other: FormTemplaceDocDentisInfo[] = [
    {
      docName: 'MEDICALSERVICEUSAGEFORM',
      checked: medicalServiceUsageForm,
      onChange: () => setMedicalServiceUsageForm(!medicalServiceUsageForm),
      example: MEDICALSERVICEUSAGEFORM,
      page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    // {
    //   docName: 'SOCIALSECURITYCERTIFICATE',
    //   checked: socialSecurityCertificate,
    //   onChange: () => setSocialSecurityCertificate(!socialSecurityCertificate),
    //   example: [SOCIALSECURITYCERTIFICATE],
    //   page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    // },
    {
      docName: 'SOCIALSECURITYCERTIFICATE',
      checked: socialSecurityCertificate,
      onChange: () => setSocialSecurityCertificate(!socialSecurityCertificate),
      example: [],
      page: [],
      docMulti: [
        {
          docName: 'SOCIALSECURITYCERTIFICATE',
          example: [SOCIALSECURITYCERTIFICATE, SOCIALSECURITYCERTIFICATE_BACK],
          page: ['REGISTER', 'TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
        }
      ]
    },
    {
      docName: 'PDFINVOICE',
      checked: pdfInvoice,
      onChange: () => setPdfInvoice(!pdfInvoice),
      example: PDFINVOICE,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
    {
      docName: 'OUTSTANDINGPAYMENT',
      checked: outStandingPayment,
      onChange: () => setOutStandingPayment(!outStandingPayment),
      example: [],
      page: [],
      docMulti: [
        {
          docName: 'OUTSTANDINGPAYMENT',
          example: OUTSTANDINGPAYMENT,
          page: ['TREATMENT', 'PAYMENT'],
        },
        {
          docName: 'OUTSTANDINGPAYMENT_SAVE',
          example: [OUTSTANDINGPAYMENT_SAVE2],
          page: ['PAYMENT'],
        }
      ]
    },
    {
      docName: 'DRUGSTICKER',
      checked: drugSticker,
      onChange: () => setDrugSticker(!drugSticker),
      example: DRUGSTICKER,
      page: ['TREATMENT', 'TREATMENTHISTORY', 'PAYMENT']
    },
  ]

  const templaceDoc: TemplaceDocInfo[] = [
    {
      title: 'OPD',
      info: templaceDoc_Opd
    },
    {
      title: 'REFERRAL',
      info: templaceDoc_Referral
    },
    {
      title: 'DOCTORCERTIFICATE',
      info: templaceDoc_DoctorCertificate
    },
    {
      title: 'OTHER',
      info: templaceDoc_Other
    },
  ]

  // Frontend JavaScript/TypeScript
  async function handleBackUpData() {
    try {
      const token = getToken()
      setLoadingBackup(true)

      const response = await fetch(`${Config.REACT_APP_BASE_URL}/export-csv`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}` // ถ้ามี authentication
        }
      });

      if (!response.ok) {
        throw new Error('Failed to download backup');
      }

      // สร้าง blob จาก response
      const blob = await response.blob();

      // สร้าง URL สำหรับ download
      const url = window.URL.createObjectURL(blob);

      // สร้าง element สำหรับ download
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `backup-${new Date().toISOString().split('T')[0]}.zip`;

      // เพิ่มใน DOM และคลิก
      document.body.appendChild(a);
      a.click();

      // ลบ element ออก
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setTimeout(e => {
        setLoadingBackup(false)
      }, 100)
      console.log('Backup downloaded successfully');
    } catch (error) {
      console.error('Error downloading backup:', error)
      swalWarning('', t('BRANCH.MESSAGE.BACKUP_ERROR_AGAIN'));
    }
  }

  const handleBackUpData1 = () => {
    setLoadingBackup(true)




    // const token = getToken()

    //         const response = await fetch('/export-csv', {
    //       method: 'GET',
    //       headers: {
    //         'Authorization': `Bearer ${token}` // ถ้ามี authentication
    //       }
    //     });

    //     if (!response.ok) {
    //       throw new Error('Failed to download backup');
    //     }
    // ClinicApi.backUpData().then(async (res) => {
    //   console.log(res)
    //   if (res.status === 200 && res.data) {
    //     // สร้าง blob จาก response
    //     const blob = await res.data.blob();
    //     console.log(blob)


    //     // สร้าง URL สำหรับ download
    //     const url = window.URL.createObjectURL(blob);

    //     // สร้าง element สำหรับ download
    //     const a = document.createElement('a');
    //     a.style.display = 'none';
    //     a.href = url;
    //     a.download = `backup-${new Date().toISOString().split('T')[0]}.zip`;

    //     // เพิ่มใน DOM และคลิก
    //     document.body.appendChild(a);
    //     a.click();

    //     // ลบ element ออก
    //     window.URL.revokeObjectURL(url);
    //     document.body.removeChild(a);
    //     swalSuccess(t('BRANCH.MESSAGE.BACKUP_SUCCESS'));
    //   } else {
    //     swalWarning(t('BRANCH.MESSAGE.BACKUP_ERROR_TITLE'), t('BRANCH.MESSAGE.BACKUP_ERROR_SUBTITLE'));
    //   }
    // }).catch((e) => {
    //   console.error(e);
    //   swalWarning('', t('BRANCH.MESSAGE.BACKUP_ERROR_AGAIN'));
    // })
    //   .finally(() => {
    //     setLoadingBackup(false)
    //   })
  }

  const onRenderColorTab = useCallback((item) => {
    return {
      borderBottom: branchTab === item.tabName ? `3px solid ${colors.themeSecondColor}` : 'none',
      color: branchTab === item.tabName ? colors.themeSecondColor : '',
      transition: 'color 0.15s ease-in-out'
    }
  }, [branchTab])


  const openImageInNewTab = (base64Image: string) => {
    const newTab = window.open('_blank');
    if (newTab) {
      newTab.document.write(
        `<div style="background-color:#0e0e0e; display:flex; justify-content:center; align-items:center; margin:-8px; width:100vw; height:100vh; overflow:hidden;" >
        <img src="${base64Image}" style="max-width: 100%; height: auto;" alt="Base64 Image" />
        </div>`
      );
      newTab.document.title = "Base64 Image";
    } else {
      alert("Unable to open new tab. Please allow pop-ups.");
    }
  };


  const renderErrorWorkTime = (index: number) => {
    if (branchTimes.length) {
      const data: any = branchTimes[index]
      const dayCurrent = Object.keys(data.days).filter((day) => data.days[day] === true)
      const check = branchTimes.some((item, num) => Object.entries(item.days).some(([day, value]) => dayCurrent.includes(day) && value) && index !== num)
      if (check) {
        return (<HelperText label={t('BRANCH.MESSAGE.ERROR_MESSAGE.DATE_ALREADY_SELECT')} />)
      } else if (!dayCurrent.length) {
        return (<HelperText label={errorMessage.WORK_TIME} />)
      } else {
        return <></>
      }
    } else {
      return <></>
    }
  }


  return (
    <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box !important', boxShadow: '0px 3px 6px #0000001a !important', border: '1px solid #e5e5e5 !important', height: '100%', backgroundColor: colors.white }}>
      <Loading show={loadingBackup} />
      <AlertModal
        isOpen={isOpenAlertModal}
        handleClose={() => {
          setIsOpenAlertModal(false)
        }}
        type='warning'
        title={t('ยืนยันการเปลี่ยนรูปแบบใบเสร็จตั้งต้น')}
        message={t('รูปแบบใบเสร็จตั้งต้นที่เลือกยังไม่เปิดใช้งาน คุณต้องการเปลี่ยนรูปแบบใบเสร็จตั้งต้น เป็น ใบเสร็จ A5 ใช่หรือไม่')}
        onSubmit={{
          onClick: () => {
            setIsOpenAlertModal(false)
            submitUpdate()
          }
        }}
        onCancel={{
          onClick: () => {
            setIsOpenAlertModal(false)
          }
        }}
      />
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <HeaderLabel
          text={t('BRANCH.TITLE_UPDATE')}
          goBack={routeName.branch}
          disabledSend={disabledSubmit}
          onSubmit={submitUpdate}
          navigator={{ previousTo: routeName.branch, previousTitle: t('BRANCH.TITLE'), currentTitle: t('BRANCH.TITLE_UPDATE') }}
          componentButton={(
            <Box mr={3}>
              <MainButton
                disabled={loadingBackup}
                title={t('Backup Data')}
                onClick={() => handleBackUpData()}
                type="primary"
                variant="contained"
              />
            </Box>
          )}
        />
        <Box sx={{ background: '#ffffff 0% 0% no-repeat padding-box', boxShadow: '0px 3px 6px #0000001a', border: '1px solid #e5e5e5', mx: '24px', mb: '24px', height: '100%', overflow: 'hidden', borderRadius: '8px' }}>
          <Box sx={{ height: '100vh', overflow: 'hidden', p: '16px' }}>
            <Grid container spacing={2}>
              <Grid item xs={2}>
                <UseStyles.UploadImage className="align-content-center flex-center">
                  <UploadImage setValue={uploadBranchLogo} pathFile={branchLogoData} />
                </UseStyles.UploadImage>
                <Box padding={'8px 0px'} display='flex' flexDirection='column' gap='8px'>
                  <Box>
                    <Typography className="mb-1" sx={{ fontWeight: 500 }}>
                      {t('BRANCH.INPUT.IMAGE.COLOR')}
                    </Typography>
                    <Box className="mt-1" display={branchImageData ? 'none' : 'block'}>
                      <Box className="d-none">
                        <input id="uploadFiles" type="file" accept=".jpg, .jpeg, .png, .heic .webp" onChange={uploadBranchImage} />
                      </Box>
                      <ButtonCustom
                        variant="text"
                        textButton={t('BRANCH.INPUT.IMAGE.ADD')}
                        onClick={() => {
                          $('#uploadFiles').click()
                        }}
                        btnStyle={{ fontSize: 16 }}
                      />
                    </Box>
                    {branchImageData &&
                      <Box className="d-flex align-items-center overflow-hidden">
                        <label
                          htmlFor={`contained-button-file-0`}
                          className={`d-flex align-items-center mr-3 text-ellipsis  ${branchImageData ? 'cursor-pointer' : ''}`}
                          onClick={() => {
                            if (branchImageDataId !== 0) window.open(branchImageData)
                            else openImageInNewTab(branchImageData)
                          }}
                        >
                          <img src={icons.attachmentLine} alt="" className={'mr-2'} />
                          <span className='text-ellipsis' style={{ textDecoration: branchImageData ? 'underline' : 'none' }}>{branchImageDataId !== 0 ? branchImageData.split('?')[0].split('branches/')[1] : branchImageData}</span>
                        </label>
                        <img src={icons.trashOutlined}
                          onClick={(e) => {
                            setBranchImage(objImage)
                            setBranchImageData(undefined)
                          }}
                          alt="" className="cursor-pointer ml-auto" />
                      </Box>
                    }
                  </Box>
                  <Box>
                    <Typography className="mb-1" sx={{ fontWeight: 500 }}>
                      {t('BRANCH.INPUT.IMAGE.BLACK_WHITE')}
                    </Typography>
                    <Box className="mt-1" display={branchLogoThermalData ? 'none' : 'block'}>
                      <Box className="d-none">
                        <input id="uploadFiles-bw" multiple type="file" accept=".jpg, .jpeg, .png, .heic .webp" onChange={uploadBranchLogoThermal} />
                      </Box>
                      <ButtonCustom
                        variant="text"
                        textButton={t('BRANCH.INPUT.IMAGE.ADD')}
                        onClick={() => {
                          $('#uploadFiles-bw').click()
                        }}
                        btnStyle={{ fontSize: 16 }}
                      />
                    </Box>
                    {branchLogoThermalData &&
                      <Box className="d-flex align-items-center overflow-hidden">
                        <label
                          htmlFor={`contained-button-file-0`}
                          className={`d-flex align-items-center mr-3 text-ellipsis  ${branchLogoThermalData ? 'cursor-pointer' : ''}`}
                          onClick={() => {
                            if (branchLogoThermalDataId !== 0) window.open(branchLogoThermalData)
                            else openImageInNewTab(branchLogoThermalData)
                          }
                          }
                        >
                          <img src={icons.attachmentLine} alt="" className={'mr-2'} />
                          <span className='text-ellipsis' style={{ textDecoration: branchLogoThermalData ? 'underline' : 'none' }}>{branchLogoThermalDataId !== 0 ? branchLogoThermalData.split('?')[0].split('branches/')[1] : branchLogoThermalData}</span>
                        </label>
                        <img src={icons.trashOutlined}
                          onClick={(e) => {
                            setBranchLogoThermal(objImage)
                            setBranchLogoThermalData(undefined)
                          }}
                          alt="" className="cursor-pointer ml-auto" />
                      </Box>
                    }
                  </Box>
                </Box>
                {/* <Box padding={'8px 0px'} display='flex' flexDirection='column' gap='8px'>
                    <Box>
                      <Typography className="mb-1" sx={{ fontWeight: 500 }}>
                        {t('BRANCH.INPUT.IMAGE.COLOR')}
                      </Typography>
                      <Box className="mt-1" display={branchImageData ? 'none' : 'block'}>
                        <Box className="d-none">
                          <input id="uploadFiles" type="file" accept=".jpg, .jpeg, .png, .heic" onChange={uploadBranchImage} />
                        </Box>
                        <ButtonCustom
                          variant="text"
                          textButton={t('BRANCH.INPUT.IMAGE.ADD')}
                          onClick={() => {
                            $('#uploadFiles').click()
                          }}
                          btnStyle={{ fontSize: 16 }}
                        />
                      </Box>
                      {branchImageData &&
                        <Box className="d-flex align-items-center overflow-hidden">
                          <label
                            htmlFor={`contained-button-file-0`}
                            className={`d-flex align-items-center mr-3 text-ellipsis  ${branchImageData ? 'cursor-pointer' : ''}`}
                            onClick={() => {
                              // branchImageData && window.open(branchImageData)
                              branchImageData && openImageInNewTab(branchImageData)
                            }}
                          >
                            <img src={icons.attachmentLine} alt="" className={'mr-2'} />
                            <span className='text-ellipsis' style={{ textDecoration: branchImageData ? 'underline' : 'none' }}>{branchImageData}</span>
                          </label>
                          <img src={icons.trashOutlined}
                            onClick={(e) => {
                              setBranchImage(objImage)
                              setBranchImageData(undefined)
                            }}
                            alt="" className="cursor-pointer ml-auto" />
                        </Box>
                      }
                    </Box>
                    <Box>
                      <Typography className="mb-1" sx={{ fontWeight: 500 }}>
                        {t('BRANCH.INPUT.IMAGE.BLACK_WHITE')}
                      </Typography>
                      <Box mt={1} display={branchLogoThermalData ? 'none' : 'block'}>
                        <Box className="d-none">
                          <input id="uploadFiles-bw" multiple type="file" accept=".jpg, .jpeg, .png, .heic" onChange={uploadBranchLogoThermal} />
                        </Box>
                        <ButtonCustom
                          variant="text"
                          textButton={t('BRANCH.INPUT.IMAGE.ADD')}
                          onClick={() => {
                            $('#uploadFiles-bw').click()
                          }}
                          btnStyle={{ fontSize: 16 }}
                        />
                      </Box>
                      {branchLogoThermalData &&
                        <Box sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
                          <label
                            htmlFor={`contained-button-file-0`}
                            className={`d-flex align-items-center mr-3 text-ellipsis  ${branchLogoThermalData ? 'cursor-pointer' : ''}`}
                            onClick={() => {
                              branchLogoThermalData && openImageInNewTab(branchLogoThermalData)
                              // branchLogoThermalData && window.open(branchLogoThermalData)
                            }}>
                            <img src={icons.attachmentLine} alt="" className={'mr-2'} />
                            <span className='text-ellipsis' style={{ textDecoration: branchLogoThermalData ? 'underline' : 'none' }}>{branchLogoThermalData}</span>
                          </label>
                          <img src={icons.trashOutlined}
                            onClick={(e) => {
                              setBranchLogoThermal(objImage)
                              setBranchLogoThermalData(undefined)
                            }}
                            alt="" className="cursor-pointer ml-auto" />
                        </Box>
                      }
                    </Box>
                  </Box> */}
                <Box mt={3}>
                  <Divider className="mx-0 mt-3 d-xl-none" sx={{ backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                </Box>
              </Grid>
              <Grid item xs={10}>
                <Box sx={{ overflow: 'auto', width: '100%', whiteSpace: 'nowrap', borderBottom: `1px solid ${colors.extraLightBlue}`, flex: 'none', }}>
                  {branchTabInfo.map((item, index: number) => {
                    return (
                      <UseStyles.ButtonTab
                        key={index}
                        className={`btn ${item?.className || ''}`}
                        style={{ ...onRenderColorTab(item), ...item?.style }}
                        type={'button'}
                        onClick={(e) => setBranchTab(item.tabName)}
                      >
                        {item?.textName || t(`BRANCH.TAB.${item.tabName}`)}{item?.require && '*' || ''}
                      </UseStyles.ButtonTab>
                    )
                  })}
                </Box>
                <Box sx={{ width: '100%', height: 'calc(100vh - 30vh)', overflowY: 'auto', overflowX: 'hidden' }}>
                  {branchTab === 'INFORMATION' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'INFORMATION' ? 'block' : 'none' }}>
                      <Typography className="mb-3" sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TAB.SIMPLE_INFORMATION')}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} >
                          <Grid container spacing={2}>
                            <Grid item xs={2}>
                              <TextInput
                                inputProps={{ maxLength: 3 }}
                                label={t('BRANCH.INPUT.BRANCH_CODE')}
                                value={branchCode}
                                onChange={(event) => {
                                  setBranchCode(event.target.value)
                                  setErrorMessage({ ...errorMessage, BRANCH_CODE: '' })
                                }}
                                helperText={
                                  errorMessage.BRANCH_CODE ||
                                  errorMessage.IS_DUPLICATE_BRANCH_CODE ||
                                  errorMessage.BRANCH_CODE_STRING_BASE ||
                                  errorMessage.BRANCH_CODE_STRING_EMPTY ||
                                  errorMessage.BRANCH_CODE_MAXIMUM_LENGTH ||
                                  errorMessage.BRANCH_CODE_ANY_REQUIRED
                                }
                                required={true}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={2}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_NUMBER')}
                                value={branchNumber}
                                onChange={(event) => {
                                  setBranchNumber(event.target.value)
                                  setErrorMessage({ ...errorMessage, BRANCH_NUMBER: '' })
                                }}
                                helperText={
                                  errorMessage.BRANCH_NUMBER ||
                                  errorMessage.IS_DUPLICATE_BRANCH_NUMBER ||
                                  errorMessage.BRANCH_NUMBER_STRING_BASE ||
                                  errorMessage.BRANCH_NUMBER_STRING_EMPTY ||
                                  errorMessage.BRANCH_NUMBER_MAXIMUM_LENGTH ||
                                  errorMessage.BRANCH_NUMBER_ANY_REQUIRED
                                }
                                required={true}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_NAME')}
                                value={branchName}
                                onChange={(event) => {
                                  setBranchName(event.target.value)
                                  setErrorMessage({ ...errorMessage, BRANCH_NAME: '' })
                                }}
                                helperText={
                                  errorMessage.BRANCH_NAME ||
                                  errorMessage.IS_DUPLICATE_BRANCH_NAME ||
                                  errorMessage.BRANCH_NAME_STRING_BASE ||
                                  errorMessage.BRANCH_NAME_STRING_EMPTY ||
                                  errorMessage.BRANCH_NAME_MAXIMUM_LENGTH ||
                                  errorMessage.BRANCH_NAME_ANY_REQUIRED
                                }
                                required={true}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_NAME_EN')}
                                value={branchNameEn}
                                onChange={(event) => {
                                  setBranchNameEn(event.target.value)
                                }}
                                helperText={
                                  errorMessage.BRANCH_NAME_EN ||
                                  errorMessage.IS_DUPLICATE_BRANCH_NAME_EN ||
                                  errorMessage.BRANCH_NAME_EN_STRING_BASE ||
                                  errorMessage.BRANCH_NAME_EN_STRING_EMPTY ||
                                  errorMessage.BRANCH_NAME_EN_MAXIMUM_LENGTH ||
                                  errorMessage.BRANCH_NAME_EN_ANY_REQUIRED
                                }
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12} >
                          <Grid container spacing={2}>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_LICENSE')}
                                value={branchLicense}
                                onChange={(event) => {
                                  setBranchLicense(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_LICENSE}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_TAX')}
                                value={branchTax}
                                onChange={(event) => {
                                  setBranchTax(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_TAX}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.HOSPITAL_NAME')}
                                value={hospitalName}
                                onChange={(event) => {
                                  setHospitalName(event.target.value)
                                }}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.HOSPITAL_CODE')}
                                value={hospitalCode}
                                onChange={(event) => {
                                  setHospitalCode(event.target.value)
                                }}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_PHONE')}
                                value={branchPhone}
                                onChange={(event) => {
                                  setBranchPhone(event.target.value)
                                  setErrorMessage({ ...errorMessage, BRANCH_PHONE: '' })
                                }}
                                helperText={errorMessage.BRANCH_PHONE}
                                required={true}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_TEL')}
                                value={branchTel}
                                onChange={(event) => {
                                  setBranchTel(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_TEL}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_FAX')}
                                value={branchFax}
                                onChange={(event) => {
                                  setBranchFax(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_FAX}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_LINE')}
                                value={branchLine}
                                onChange={(event) => {
                                  setBranchLine(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_LINE}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_WEBSITE')}
                                value={branchWebsite}
                                onChange={(event) => {
                                  setBranchWebsite(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_WEBSITE}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_EMAIL')}
                                value={branchEmail}
                                onChange={(event) => {
                                  setBranchEmail(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_EMAIL}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_FACEBOOK')}
                                value={branchFacebook}
                                onChange={(event) => {
                                  setBranchFacebook(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_FACEBOOK}
                                fullWidth
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <TextInput
                                label={t('BRANCH.INPUT.BRANCH_INSTAGRAM')}
                                value={branchInstagram}
                                onChange={(event) => {
                                  setBranchInstagram(event.target.value)
                                }}
                                helperText={errorMessage.BRANCH_INSTAGRAM}
                                fullWidth
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mx: 0, my: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                      <Typography className="mb-3" sx={{ fontSize: '18px', fontWeight: 500 }}>{t('BRANCH.TAB.ADDRESS_INFORMATION')} </Typography>
                      <Grid container spacing={2}>
                        <Grid item sm={6} lg={4} xl={3} width="100%">
                          <AutocompleteSelect
                            labelId={`lb-parent-country`}
                            inputLabel={t('PERSONNEL.INPUT.INFORMATION.COUNTRY')}
                            noOptionsText={t('REGISTER.FORM.NOT_FOUND')}
                            options={countryOptions}
                            getOptionLabel={(option: any) => option.countryNameTh}
                            renderOption={(props, option: any) => (
                              <Box key={option} component="li" {...props}>
                                {option.countryNameTh}
                              </Box>
                            )}
                            onchange={(e, value: any) => {
                              if (value) {
                                const val: number = value.countryId
                                setCountry(val)
                              }
                            }}
                            key={`lb-parent-country`}
                            value={_.find(countryOptions, (countries) => countries.countryId === country) || null}
                            disableClearable
                          />
                        </Grid>
                        <Grid item sm={6} lg={8} xl={9} width={'100%'}>
                          <SelectAddress
                            patientId={0}
                            countryId={country}
                            provinceId={branchSelectAddress?.province_id}
                            districtId={branchSelectAddress?.district_id}
                            subDistrictId={branchSelectAddress?.sub_district_id}
                            postcode={branchSelectAddress?.postcode}
                            callbackAddress={(address: any) => {
                              const { provinceId, districtId, subDistrictId, postcode } = address;
                              setBranchSelectAddress({
                                province_id: provinceId,
                                district_id: districtId,
                                sub_district_id: subDistrictId,
                                postcode: postcode
                              });
                            }
                            }
                            height="40px"
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextAreaInput
                            onChange={(event) => {
                              setBranchAddress(event.target.value)
                            }}
                            value={branchAddress}
                            label={t('BRANCH.INPUT.BRANCH_ADDRESS')}
                            helperText={errorMessage.BRANCH_ADDRESS}
                            fullWidth
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextAreaInput
                            onChange={(event) => {
                              setBranchAddressEn(event.target.value)
                            }}
                            value={branchAddressEn}
                            label={t('BRANCH.INPUT.BRANCH_ADDRESS_EN')}
                            helperText={errorMessage.BRANCH_ADDRESS_EN}
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {branchTab === 'RECIEVE_STICKER' && (
                    <FormBranchReceiptSticker
                      addressRecieptSameBranch={addressRecieptSameBranch}
                      setAddressRecieptSameBranch={setAddressRecieptSameBranch}
                      clearErrorMessage={clearErrorMessage}
                      countryOptions={countryOptions}
                      receiptCountry={receiptCountry}
                      setRecieptCountry={setRecieptCountry}
                      receiptSelectAddress={receiptSelectAddress}
                      setRecieptSelectAddress={setRecieptSelectAddress}
                      errorMessage={errorMessage}
                      receiptAddress={receiptAddress}
                      setRecieptAddress={setRecieptAddress}
                      receiptAddressEn={receiptAddressEn}
                      setRecieptAddressEn={setRecieptAddressEn}
                      showCostEstimateReceipt={showCostEstimateReceipt}
                      setShowCostEstimateReceipt={setShowCostEstimateReceipt}
                      defaultReceipt={defaultReceipt}
                      setDefaultReceipt={setDefaultReceipt}
                      defaultReceiptRemarkStatus={defaultReceiptRemarkStatus}
                      setDefaultReceiptRemarkStatus={setDefaultReceiptRemarkStatus}
                      defaultReceiptPracticeStatus={defaultReceiptPracticeStatus}
                      setDefaultReceiptPracticeStatus={setDefaultReceiptPracticeStatus}
                      thermalFormat={thermalFormat}
                      setThermalFormat={setThermalFormat}
                      thermalRemark={thermalRemark}
                      setThermalRemark={setThermalRemark}
                      receiptNumberPrefix={receiptNumberPrefix}
                      setReceiptNumberPrefix={setReceiptNumberPrefix}
                      snType={snType}
                      imgQRData={imgQRData}
                      setImgQRData={setImgQRData}
                      setQRCodeReceipt={setQRCodeReceipt}
                      qrCodeReceiptDetail={qrCodeReceiptDetail}
                      setQRCodeReceiptDetail={setQRCodeReceiptDetail}
                      stickerFormat={stickerFormat}
                      setStickerFormat={setStickerFormat}
                    />
                  )}
                  {branchTab === 'TEMPLACE_DOC' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'TEMPLACE_DOC' ? 'block' : 'none' }}>
                      <Typography mb={2} sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TEMPLATE_EXPORT')}
                      </Typography>
                      <Box pl={3}>
                        <Box><FormTemplaceDocDentist templaceDoc={templaceDoc} /></Box>
                        <Box mt={3} mb={3}>
                          <Divider sx={{ mx: 0, mt: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                        </Box>
                        <Typography mb={2} sx={{ fontSize: '16px', fontWeight: 500 }}>
                          {t('BRANCH.INPUT.TREATMENTDOCUMENT')}
                        </Typography>
                        <Grid item sx={{ width: '100%', pl: 3 }}>
                          <Grid container>
                            <Grid item xs={12}>
                              <Box display="flex" alignItems="center" gap={3}>
                                <CheckboxButton
                                  label={t('PDF_INVOICE.HEADER')}
                                  key={'addressRecieptSameBranch'}
                                  checked={pdfInvoiceTreatment || false}
                                  onChange={() => {
                                    if (pdfInvoiceTreatment) setPdfInvoiceTreatmentCondition('1')
                                    setPdfInvoiceTreatment(!pdfInvoiceTreatment)
                                  }
                                  }
                                />
                                <Box>
                                  <MainButton
                                    title={t('BRANCH.INPUT.VIEW_EXAMPLE')}
                                    variant={'outlined'}
                                    type={'primary'}
                                    style={{
                                      height: '25px',
                                      padding: '4px 10px',
                                      fontSize: '13px',
                                      whiteSpace: 'nowrap'
                                    }}
                                    onClick={() => {
                                      dispatch(showModal())
                                      setModalImg(!modalImg)
                                    }}
                                  />
                                </Box>
                              </Box>
                            </Grid>
                            <Grid item sm={12} md={3}>
                              <Box sx={{ paddingLeft: '32px' }}>
                                <Box>
                                  {t('BRANCH.INPUT.CONDITION')}
                                </Box>
                                <RadioButton
                                  name="radio-buttons-group"
                                  onChange={(e) => setPdfInvoiceTreatmentCondition(e.target.value)}
                                  sx={{ gap: '0px' }}
                                  defaultValue={pdfInvoiceTreatmentCondition}
                                  value={pdfInvoiceTreatmentCondition}
                                  options={[
                                    { label: t('BRANCH.INPUT.CONDITION_1'), value: '0', disabled: !pdfInvoiceTreatment },
                                    { label: t('BRANCH.INPUT.CONDITION_2'), value: '1', disabled: !pdfInvoiceTreatment },
                                  ]}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Box mt={3} mb={3}>
                          <Divider sx={{ mx: 0, mt: 3, backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important` }} />
                        </Box>
                        <Typography mb={2} sx={{ fontSize: '16px', fontWeight: 500 }}>
                          {t('BRANCH.TEMPLATE_BILL')}
                        </Typography>
                        <Grid item sx={{ width: '100%', pl: 3 }}>
                          <Grid container>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA4DEFAULT')} key={'addressRecieptSameBranch'} disabled checked={receiptA4Default || false} onChange={() => setReceiptA4Default(!receiptA4Default)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA4ORIGINAL')} key={'addressRecieptSameBranch'} checked={receiptA4Original || false} onChange={() => setReceiptA4Original(!receiptA4Original)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA4COPY')} key={'addressRecieptSameBranch'} checked={receiptA4Copy || false} onChange={() => setReceiptA4Copy(!receiptA4Copy)} />
                            </Grid>
                            {/* A5 */}
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5DEFAULT')} key={'addressRecieptSameBranch'} disabled checked={receiptA5Default || false} onChange={() => setReceiptA5Default(!receiptA5Default)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5ORIGINAL')} key={'addressRecieptSameBranch'} checked={receiptA5Original || false} onChange={() => setReceiptA5Original(!receiptA5Original)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5COPY')} key={'addressRecieptSameBranch'} checked={receiptA5Copy || false} onChange={() => setReceiptA5Copy(!receiptA5Copy)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5DEFAULTEN')} key={'addressRecieptSameBranch'} checked={receiptA5DefaultEn || false} onChange={() => setReceiptA5DefaultEn(!receiptA5DefaultEn)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5ORIGINALEN')} key={'addressRecieptSameBranch'} checked={receiptA5OriginalEn || false} onChange={() => setReceiptA5OriginalEn(!receiptA5OriginalEn)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5COPYEN')} key={'addressRecieptSameBranch'} checked={receiptA5CopyEn || false} onChange={() => setReceiptA5CopyEn(!receiptA5CopyEn)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton
                                label={t('BRANCH.INPUT.RECEIPTA5DEFAULTLANDSCAPE')}
                                key={'addressRecieptSameBranch'}
                                checked={receiptA5DefaultLandscape || false}
                                onChange={() => setReceiptA5DefaultLandscape(!receiptA5DefaultLandscape)}
                              />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton
                                label={t('BRANCH.INPUT.RECEIPTA5ORIGINALLANDSCAPE')}
                                key={'addressRecieptSameBranch'}
                                checked={receiptA5OriginalLandscape || false}
                                onChange={() => setReceiptA5OriginalLandscape(!receiptA5OriginalLandscape)}
                              />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.RECEIPTA5COPYLANDSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5CopyLandscape || false} onChange={() => setReceiptA5CopyLandscape(!receiptA5CopyLandscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_DF_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5DfLscape || false} onChange={() => setReceiptA5DfLscape(!receiptA5DfLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_DF_ORG_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5DfOrgLscape || false} onChange={() => setReceiptA5DfOrgLscape(!receiptA5DfOrgLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_DF_COPY_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5DfCopyLscape || false} onChange={() => setReceiptA5DfCopyLscape(!receiptA5DfCopyLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_FIX_DF_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5FixDfLscape || false} onChange={() => setReceiptA5FixDfLscape(!receiptA5FixDfLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_FIX_DF_ORG_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5FixDfOrgLscape || false} onChange={() => setReceiptA5FixDfOrgLscape(!receiptA5FixDfOrgLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('RECEIPT.A5_FIX_DF_COPY_LSCAPE')} key={'addressRecieptSameBranch'} checked={receiptA5FixDfCopyLscape || false} onChange={() => setReceiptA5FixDfCopyLscape(!receiptA5FixDfCopyLscape)} />
                            </Grid>
                            <Grid item sm={6} lg={3} xl={3}>
                              <CheckboxButton label={t('BRANCH.INPUT.THERMAL')} key={'addressRecieptSameBranch'} disabled checked={receiptThermal || false} onChange={() => setReceiptThermal(!receiptThermal)} />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  )}
                  {branchTab === 'WORK_TIME' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'WORK_TIME' ? 'block' : 'none' }}>
                      <Typography mb={3} sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TAB.WORK_TIME_TITLE')}
                      </Typography>
                      <Table sx={{ border: `1px solid ${colors.lightGray}`, minWidth: 800, borderCollapse: 'separate', borderSpacing: 0, borderRadius: '10px', overflow: 'hidden' }}>
                        <TableHead sx={{ backgroundColor: '#2F4269' }}>
                          <TableRow>
                            <TableCell sx={{ fontSize: '16px', color: colors.white, borderTopLeftRadius: '10px' }}> {t('BRANCH.INPUT.WORK_DATE_COL')} </TableCell>
                            <TableCell sx={{ fontSize: '16px', color: colors.white, width: '320px' }}>{t('TIME_DURATION_TYPE.DAY')}</TableCell>
                            <TableCell sx={{ fontSize: '16px', color: colors.white }} > {t('BRANCH.INPUT.WORK_TIME')}</TableCell>
                            <TableCell align="center" sx={{ fontSize: '16px', color: colors.white, borderTopRightRadius: '10px' }} > Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={4}>
                              <a className="btn text-second" onClick={() => {
                                setErrorMessage((pre) => ({ ...pre, WORK_TIME_LIST: '' }))
                                addBranchTime()
                              }}>
                                <span style={{ color: colors.themeSecondColor }}>+</span>
                                <span className="ml-1" style={{ color: colors.themeSecondColor }}>
                                  {t('BRANCH.TAB.ADD_ITEM_WORK')}
                                </span>
                              </a>
                              {(errorMessage.WORK_TIME_LIST) &&
                                <Box padding='0 0 0 12px'>
                                  <HelperText label={errorMessage.WORK_TIME_LIST} />
                                </Box>
                              }
                            </TableCell>
                          </TableRow>
                          {branchTimes.map((branchTime: any, iBranchTime) => (
                            <TableRow key={`row-${iBranchTime}`} sx={{ 'td': { padding: errorMessage.WORK_TIME ? '.5rem .5rem 1.5rem .5rem' : '' } }}>
                              <TableCell>
                                <BasicSelect
                                  onchange={(event) => {
                                    const value = event.target.value
                                    if (value) {
                                      handleChangeBranchTimeType(value, iBranchTime)
                                    }
                                  }}
                                  label={''}
                                  selectId="select-status"
                                  value={branchTime.typetime}
                                  labelId="label-status"
                                  options={[
                                    <MenuItem key="1" value="OPEN">
                                      {t('BRANCH.INPUT.WORK_DATE_TYPE_OPEN')}
                                    </MenuItem>,
                                    <MenuItem key="2" value="CLOSE">
                                      {t('BRANCH.INPUT.WORK_DATE_TYPE_CLOSE')}
                                    </MenuItem>
                                  ]}
                                />
                              </TableCell>
                              <TableCell>
                                {dateOfWeek.map((day, i) => (
                                  <UseStyles.BtnDay
                                    key={day}
                                    className={`btn mx-1 text-nowrap text-center px-1 btn-day d-inline-flex align-items-center justify-content-center ${branchTime.days[day.toLowerCase()] ? 'active' : ''} ${branchTime.typetime === 'OPEN' ? 'open' : 'close'
                                      }`}
                                    onClick={(e) => {
                                      setErrorMessage((pre) => ({ ...pre, WORK_TIME: '' }))
                                      handleChangeBranchTimeDate(day.toLowerCase(), iBranchTime)
                                    }}
                                  >
                                    {t(`DAY_SHORT_${day.toUpperCase()}`)}
                                  </UseStyles.BtnDay>
                                ))}
                                {(errorMessage.WORK_TIME) &&
                                  <Box position={'absolute'} marginTop='6px'>
                                    {renderErrorWorkTime(iBranchTime)}
                                  </Box>
                                }
                              </TableCell>
                              <TableCell>
                                <InputNewRangeTimePicker
                                  value={[moment(branchTime.timeStart, 'HH:mm').format('HH:mm'), moment(branchTime.timeEnd, 'HH:mm').format('HH:mm')]}
                                  onChange={(e) => handleChangeBranchTime(e, iBranchTime)}
                                  disabled={branchTime.typetime === 'CLOSE'}
                                  style={{ maxWidth: '300px' }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <IconButton
                                  className={'btn-delete'}
                                  disableFocusRipple
                                  disableRipple
                                  disableTouchRipple
                                  aria-label="delete"
                                  onClick={(e) => deleteBranchTime(e, iBranchTime)}
                                  sx={{
                                    backgroundColor: 'transparent !important',
                                    padding: 0,
                                    '&:disabled': {
                                      filter: 'grayscale(1)',
                                      opacity: 0.6
                                    }
                                  }}
                                >
                                  <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  )}
                  {branchTab === 'SERVICE_POINT' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'SERVICE_POINT' ? 'block' : 'none' }}>
                      <Typography mb={3} sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TAB.SERVICE_POINT_BRANCH')}
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sx={{ width: '100%' }}>
                          <Box mb={1}>
                            <Box
                              component="a"
                              className="btn text-second p-0"
                              sx={{
                                cursor: canAddServicePoint ? 'pointer' : 'not-allowed',
                                display: 'inline-flex',
                                alignItems: 'center'
                              }}
                              onClick={canAddServicePoint ? addBranchServicePoint : undefined}
                            >
                              <span style={{ color: canAddServicePoint ? colors.themeSecondColor : colors.disabledGray }}>+</span>
                              <Box component="span" ml={1} sx={{ color: canAddServicePoint ? colors.themeSecondColor : colors.disabledGray }}>
                                {t('BRANCH.INPUT.ADD_SERVICE_POINT')}
                              </Box>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4} sx={{ width: '100%' }}>
                          <Grid container spacing={3}>
                            {branchServicePoints.map((branchServicePoint: any, iBranchServicePoint) => (
                              <Grid item xs={12} key={`service-point-${iBranchServicePoint}`} sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                <BasicSelect
                                  onchange={(event) => {
                                    const servicePointId = event.target.value
                                    if (servicePointId) {
                                      handleChangeServicePoint(servicePointId, iBranchServicePoint)
                                    }
                                  }}
                                  label={t('BRANCH.SERVICE_POINT')}
                                  selectId="select-status"
                                  value={branchServicePoint.servicePointId}
                                  labelId="label-status"
                                  options={servicePoints.map((servicePoint: any, iServicePoint) => (
                                    <MenuItem
                                      key={servicePoint.servicePointId}
                                      value={servicePoint.servicePointId}
                                      className={`${_.some(branchServicePoints, (i) => i.servicePointId === servicePoint.servicePointId) ? 'd-none' : ''}`}
                                      disabled={_.some(branchServicePoints, { servicePointId: servicePoint.servicePointId }) ? true : false}
                                    >
                                      {servicePoint.servicePointName}
                                    </MenuItem>
                                  ))}
                                  helperText={branchServicePoint.servicePointId === 0 ? errorMessage.SERVICE_POINT : ''}
                                />
                                <IconButton
                                  className={'btn-delete ml-3'}
                                  disableFocusRipple
                                  disableRipple
                                  disableTouchRipple
                                  disabled={branchServicePoints.length === 1 || iBranchServicePoint === 0}
                                  aria-label="delete"
                                  onClick={(e) => deleteBranchServicePoint(e, iBranchServicePoint)}
                                  sx={{
                                    backgroundColor: 'transparent !important',
                                    padding: 0,
                                    ml: 2,
                                    '&:disabled': {
                                      filter: 'grayscale(1)',
                                      opacity: 0.6
                                    }
                                  }}
                                >
                                  <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                </IconButton>
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                  {branchTab === 'BANK' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'BANK' ? 'block' : 'none' }}>
                      <Typography mb={3} sx={{ fontSize: '18px', fontWeight: 500 }}>
                        {t('BRANCH.TAB.BANK_NAME')}
                      </Typography>
                      <UseStyles.BankType sx={{ ml: { xl: 2 } }}>
                        {banks.map((bank: any) => (
                          <Box
                            key={bank.bankId}
                            component="a"
                            className={`btn bg-second-color bank-logo p-0 mx-1 mb-3 ${branchBanks.length && branchBanks.find((bb) => bb.bankId === bank.bankId) ? 'active' : ''}`}
                            onClick={() => selectBank(bank.bankId)}
                            sx={{ display: 'inline-block', cursor: 'pointer' }}
                          >
                            <img
                              src={bank.image ? `${fileUrl}/${bank.image?.filePath}/${bank.image?.fileName}` : bank.bankLogo}
                              alt=""
                              onError={onImgError}
                            />
                          </Box>
                        ))}
                      </UseStyles.BankType>
                      <UseStyles.CustomTable sx={{ ml: { xl: 2 }, overflow: 'auto' }} className="custom-scroll">
                        <Table className={'table'} sx={{ minWidth: '800px' }}>
                          <TableHead>
                            <TableRow>
                              <TableCell className="border-0" sx={{ width: '22%' }}>
                                {t('BRANCH.INPUT.BANK_NAME')}
                              </TableCell>
                              <TableCell className="border-0" sx={{ width: { lg: '280px' } }}>
                                <Box component="span" mr={2}>{t('BRANCH.INPUT.SERVICE_SUPPORT')}</Box>
                                <ButtonInfoSimple
                                  text={
                                    <>
                                      {t('BRANCH.PAYMENT.BANK')}
                                      <br />
                                      {t('BRANCH.PAYMENT.CREDIT')}
                                    </>
                                  }
                                />
                              </TableCell>
                              <TableCell className="border-0">{t('BRANCH.INPUT.BANK_ACCOUNT_NAME_TRANSFER')}</TableCell>
                              <TableCell className="border-0">{t('BRANCH.INPUT.BANK_ACCOUNT_NUMBER')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {(!_.isEmpty(branchBanks) &&
                              branchBanks.map((branchBank: any, iBranchBank) => (
                                <TableRow key={`row-${iBranchBank}`} sx={{ 'td': { padding: (errorMessage.EMPTY_BANK_ACCOUNT_NAME || errorMessage.EMPTY_BANK_ACCOUNT_NUMBER) ? '.5rem .5rem 1rem .5rem' : '' } }}>
                                  <TableCell className="border-0">
                                    <Box display="flex" alignItems="center">
                                      <Box sx={{ width: 35, height: 35 }}>
                                        <img
                                          src={renderBankLogo(branchBank.bankId)}
                                          alt=""
                                          style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain'
                                          }}
                                          onError={onImgError}
                                        />
                                      </Box>
                                      <Box component="span" pl={2}>{branchBank.bankName}</Box>
                                    </Box>
                                  </TableCell>
                                  <TableCell className="border-0">
                                    <Box display="flex">
                                      <CheckboxButton
                                        label={t('BRANCH.INPUT.TRANSFER')}
                                        key={`transfer-${iBranchBank}`}
                                        checked={branchBank.hasTransfer === 'SUPPORT' || branchBank.hasTransfer === true}
                                        onChange={(e) => handleChangeBranchBank(e.target.checked ? 'SUPPORT' : 'NOT_SUPPORT', iBranchBank, 'hasTransfer')}
                                        disabled={branchBank.disabledTransfer}
                                      />
                                      <CheckboxButton
                                        label={t('BRANCH.INPUT.DEBIT')}
                                        key={`debit-${iBranchBank}`}
                                        checked={branchBank.hasDebit === 'SUPPORT' || branchBank.hasDebit === true}
                                        onChange={(e) => handleChangeBranchBank(e.target.checked ? 'SUPPORT' : 'NOT_SUPPORT', iBranchBank, 'hasDebit')}
                                        disabled={branchBank.disabledDebit}
                                      />
                                      <CheckboxButton
                                        label={t('BRANCH.INPUT.CREDIT')}
                                        key={`credit-${iBranchBank}`}
                                        checked={branchBank.hasCredit === 'SUPPORT' || branchBank.hasCredit === true}
                                        onChange={(e) => handleChangeBranchBank(e.target.checked ? 'SUPPORT' : 'NOT_SUPPORT', iBranchBank, 'hasCredit')}
                                        disabled={branchBank.disabledCredit}
                                      />
                                    </Box>
                                  </TableCell>
                                  <TableCell className="border-0" >
                                    <TextInput
                                      value={branchBank.bankAccountName}
                                      onChange={(event) => {
                                        const count = _.filter(branchBanks, (bank, index) => !bank.bankAccountName && index !== iBranchBank)
                                        if (!count.length) setErrorMessage((pre) => ({ ...pre, EMPTY_BANK_ACCOUNT_NAME: '' }))
                                        handleChangeBranchBank(event.target.value, iBranchBank, 'bankAccountName')
                                      }}
                                      helperText={!branchBank.disabledTransfer && !branchBank.disabledDebit && !branchBank.disabledCredi && !branchBank.bankAccountName ? errorMessage.EMPTY_BANK_ACCOUNT_NAME : ''}
                                      disabled={branchBank.disabledTransfer && branchBank.disabledDebit && branchBank.disabledCredit}
                                      fullWidth
                                    />
                                  </TableCell>
                                  <TableCell className="border-0" >
                                    <TextInput
                                      value={branchBank.bankAccountNumber}
                                      onChange={(event) => {
                                        const count = _.filter(branchBanks, (bank, index) => !bank.bankAccountNumber && index !== iBranchBank)
                                        if (!count.length) setErrorMessage((pre) => ({ ...pre, EMPTY_BANK_ACCOUNT_NUMBER: '' }))
                                        handleChangeBranchBank(event.target.value, iBranchBank, 'bankAccountNumber')
                                      }}
                                      helperText={!branchBank.disabledTransfer && !branchBank.disabledDebit && !branchBank.disabledCredit && !branchBank.bankAccountNumber ? errorMessage.EMPTY_BANK_ACCOUNT_NUMBER : ''}
                                      disabled={branchBank.disabledTransfer && branchBank.disabledDebit && branchBank.disabledCredit}
                                      fullWidth
                                    />
                                  </TableCell>
                                </TableRow>
                              ))) || (
                                <TableRow key={`empty-iBranchBank`}>
                                  <TableCell className="border-0 text-center" colSpan={4}>
                                    <Typography>{t('BRANCH.PAYMENT.NO_BANKING')}</Typography>
                                  </TableCell>
                                </TableRow>
                              )}
                          </TableBody>
                        </Table>
                      </UseStyles.CustomTable>
                    </Box>
                  )}
                  {/*  */}
                  {branchTab === 'FORMATFORM' && (
                    <Box sx={{ mt: 3, my: 3, overflow: 'auto', height: '85%', display: branchTab === 'FORMATFORM' ? 'block' : 'none' }}>
                      <FormFormatForm
                        formRegister={{ data: formRegister, setData: setFormRegister }}
                        formAppointment={{ data: formAppointment, setData: setFormAppointment }}
                      />
                    </Box>
                  )}
                  {branchTab === 'SENTTING' && (
                    <FormBranchSetting
                      showPatient={patientCodeAll}
                      setShowPatient={setPatientCodeAll}
                      appointmentTime={timeAppointment}
                      setAppointmentTime={setTimeAppointment}
                      treatment={apptService}
                      setTreatment={setApptService}
                      preveiwDf={defaultDfReport}
                      setPreveiwDf={setDefaultDfReport}
                      modelDf={defaultDfCon}
                      setModelDf={setDefaultDfCon}
                      calAdvance={calculateAdvance}
                      setCalAdvance={setCalculateAdvance}
                      showOperativeCode={showOperativeCode}
                      setShowOperativeCode={setShowOperativeCode}
                      showAppointmentSharing={showAppointmentSharing}
                      setShowAppointmentSharing={setShowAppointmentSharing}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
      {
        modalImg &&
        <ModalExamDoc
          onClose={() => setModalImg(!modalImg)}
          modalTitle={modalTitle}
        />
      }
    </Box >
  )
}
